export const translations = {
  th: {
    "app.name": "SafeSphere",
    "app.tagline": "พื้นที่ปลอดภัย เริ่มจากการเตรียมพร้อม",
    "skip.main": "ข้ามไปยังเนื้อหาหลัก",
    "nav.primary": "เมนูหลัก",
    "nav.primary_desktop": "เมนูหลักสำหรับหน้าจอขนาดใหญ่",
    "nav.primary_mobile": "เมนูหลักสำหรับอุปกรณ์เคลื่อนที่",
    "nav.home": "หน้าหลัก",
    "nav.emergency": "ฉุกเฉิน",
    "nav.disaster": "ภัยพิบัติ",
    "nav.learn": "เรียนรู้",
    "nav.search": "ค้นหา",
    "nav.family": "แผนครอบครัว",
    "nav.settings": "ตั้งค่า",
    "nav.about": "เกี่ยวกับ SafeSphere",
    "nav.secondary_desktop": "ข้อมูลเพิ่มเติม",
    "language.dialog_title": "เลือกภาษาที่อ่านสะดวก",
    "language.dialog_body": "คุณเปลี่ยนภาษาได้เสมอในการตั้งค่า",
    "language.suggested": "ภาษาที่แนะนำจากอุปกรณ์",
    "language.th": "ไทย",
    "language.en": "English",
    "language.current": "ภาษาที่ใช้อยู่",
    "language.choose": "เปลี่ยนภาษา",
    "language.confirm": "ใช้ภาษานี้",
    "status.offline_ready.title": "พร้อมใช้งานแบบออฟไลน์",
    "status.offline_ready.body": "พื้นที่นี้จะแสดงสถานะของเนื้อหาที่บันทึกไว้ในอุปกรณ์",
    "status.connection_unavailable.title": "ไม่มีการเชื่อมต่อ",
    "status.connection_unavailable.body": "ฟังก์ชันออนไลน์ไม่พร้อมใช้งาน แต่ส่วนพื้นฐานยังเปิดได้",
    "status.update_unavailable.title": "ตรวจสอบเนื้อหาใหม่ไม่ได้",
    "status.update_unavailable.body": "แอปจะแสดงสถานะการอัปเดตอย่างชัดเจนเมื่อระบบพร้อมใช้งาน",
    "status.information": "ข้อมูลระบบ",
    "content_state.ready.title": "เนื้อหาออฟไลน์พร้อมใช้งาน",
    "content_state.ready.body":
      "อุปกรณ์นี้มีชุดเนื้อหาที่ตรวจสอบแล้วและพร้อมเปิดโดยไม่ใช้อินเทอร์เน็ต",
    "content_state.never_downloaded.title": "ยังไม่มีเนื้อหาออฟไลน์",
    "content_state.never_downloaded.body":
      "โครงสร้างออฟไลน์พร้อมแล้ว แต่ยังไม่มีชุดเนื้อหาที่เผยแพร่สำหรับภาษานี้",
    "content_state.updating.title": "กำลังตรวจสอบเนื้อหาใหม่",
    "content_state.updating.body": "ระบบจะใช้ชุดเดิมต่อไปจนกว่าชุดใหม่จะผ่านการตรวจสอบครบถ้วน",
    "content_state.stale_usable.title": "เนื้อหาที่บันทึกไว้ยังเปิดได้",
    "content_state.stale_usable.body":
      "เนื้อหานี้อาจเก่า แอปจะแสดงฉบับที่บันทึกไว้จนกว่าจะตรวจสอบฉบับใหม่ได้",
    "content_state.update_failed_saved.title": "ใช้เนื้อหาที่บันทึกไว้",
    "content_state.update_failed_saved.body":
      "การอัปเดตไม่สำเร็จ ระบบกลับมาใช้ชุดที่ตรวจสอบแล้วก่อนหน้า",
    "content_state.recovery_required.title": "ต้องกู้คืนเนื้อหาออฟไลน์",
    "content_state.recovery_required.body":
      "ไม่พบชุดเนื้อหาที่สมบูรณ์ โปรดเชื่อมต่ออินเทอร์เน็ตเพื่อลองกู้คืนในภายหลัง",
    "emergency.action_label": "เข้าถึงได้รวดเร็ว",
    "emergency.action": "ดูโหมดฉุกเฉินตัวอย่าง",
    "emergency.action_hint": "พื้นที่สำหรับขั้นตอนที่ชัดเจนและสงบเมื่อคุณต้องการ",
    "contacts.reference.eyebrow": "ข้อมูลติดต่อ",
    "contacts.reference.title": "หมายเลขติดต่อฉุกเฉิน",
    "contacts.reference.unavailable":
      "ยังไม่มีหมายเลขที่ผ่านการตรวจทานและอนุมัติสำหรับแสดงในแอปนี้ ไม่ได้หมายความว่าไม่มีบริการในพื้นที่ของคุณ",
    "contacts.reference.read_only":
      "เมื่อมีข้อมูลที่อนุมัติแล้ว แอปจะแสดงเบอร์เพื่ออ่านเท่านั้น โดยไม่โทรหรือส่งข้อความให้เอง",
    "contacts.reference.directory_link": "รวมเบอร์ติดต่อสำคัญ",
    "contacts.draft.warning":
      "ฉบับรอตรวจทาน — ตัวเลขและขอบเขตด้านล่างมาจากแหล่งทางการ แต่ยังไม่ผ่านการอนุมัติเผยแพร่ขั้นสุดท้าย โปรดตรวจสอบประกาศท้องถิ่นปัจจุบันด้วย",
    "contacts.draft.medical": "ความช่วยเหลือทางการแพทย์ฉุกเฉิน",
    "contacts.draft.medical_scope":
      "แหล่ง NIEM ระบุบริการการแพทย์ฉุกเฉินตลอด 24 ชั่วโมง; ยังรอการยืนยันขอบเขตบริการปัจจุบันจากหน่วยงาน",
    "contacts.draft.police": "เหตุอันตรายเร่งด่วน",
    "contacts.draft.police_scope":
      "แหล่งที่ตรวจได้ระบุศูนย์รับแจ้งเหตุในกรุงเทพฯ จึงยังไม่กล่าวอ้างว่าใช้ครอบคลุมทั่วประเทศ",
    "contacts.draft.fire": "เหตุเพลิงไหม้และกู้ภัย",
    "contacts.draft.fire_scope":
      "ปรากฏในทำเนียบหมายเลขภาครัฐและแหล่ง กทม.; ยังรอยืนยันขอบเขตบริการนอกกรุงเทพฯ",
    "contacts.draft.source": "แหล่งอ้างอิง",
    "contacts.draft.status": "REVIEW REQUIRED",
    "contacts.draft.disaster_blocked":
      "ช่องทางข้อมูลหรือเตือนภัยพิบัติยังไม่แสดง เนื่องจากยังไม่มีแหล่งปัจจุบันที่ยืนยันขอบเขตได้ตรง",
    "directory.eyebrow": "สมุดติดต่อออฟไลน์",
    "directory.title": "รายชื่อติดต่อฉุกเฉินและบริการจำเป็น",
    "directory.short_title": "เบอร์ติดต่อ",
    "directory.body":
      "ค้นหา กรอง คัดลอก หรือแตะโทรด้วยตนเอง พร้อมดูพื้นที่ให้บริการและสถานะการตรวจทาน",
    "directory.fixture.title": "สมุดติดต่อจากแหล่งทางการ",
    "directory.fixture.body":
      "แต่ละรายการแสดงสถานะตามหลักฐานจริง รายการที่ขอบเขตยังไม่ยืนยันจะไม่ถูกอธิบายว่าใช้ได้ทั่วประเทศ",
    "directory.search": "ค้นหาบริการหรือเบอร์โทร",
    "directory.search.placeholder": "เช่น แพทย์ ไฟไหม้ น้ำ หรือจังหวัด",
    "directory.filters": "กรองตามประเภทบริการ",
    "directory.all": "ทั้งหมด",
    "directory.priority": "ทางเข้าความช่วยเหลือสำคัญ",
    "directory.services": "บริการอื่น",
    "directory.tap_note": "แตะรายการเพื่อดูที่มาและขอบเขต",
    "directory.copy": "คัดลอกเบอร์",
    "directory.copied": "คัดลอกแล้ว",
    "directory.call": "โทรด้วยตนเอง",
    "directory.call.notice": "แอปจะเปิดหน้าจอโทรหลังจากคุณแตะเท่านั้น และจะไม่โทรอัตโนมัติ",
    "directory.favorite.add": "เพิ่มรายการโปรด",
    "directory.favorite.remove": "นำออกจากรายการโปรด",
    "directory.empty.title": "ไม่พบรายการที่ตรงกัน",
    "directory.empty.body": "ลองใช้คำสั้นลงหรือเลือกประเภทอื่น ระบบจะไม่เดาผลลัพธ์เพิ่มเติม",
    "directory.close": "กลับไปยังรายการ",
    "directory.coverage": "พื้นที่ให้บริการ",
    "directory.status": "สถานะการตรวจทาน",
    "directory.status.draft": "ฉบับร่างจากแหล่งข้อมูล — รอการทบทวนโดยมนุษย์",
    "directory.status.stale": "ข้อมูลเดิม — ควรตรวจสอบแหล่งอีกครั้ง",
    "directory.status.review_required": "รอตรวจทาน — ยังไม่ใช่ข้อมูลเผยแพร่",
    "directory.status.unavailable": "ยังไม่มีข้อมูลที่ใช้ได้",
    "directory.record.official": "ข้อมูลทางการ",
    "directory.record.fixture": "ข้อมูลสมมติ",
    "directory.evidence.draft": "ฉบับร่างอ้างอิงแหล่งข้อมูล",
    "directory.evidence.review": "ขอบเขตอยู่ระหว่างตรวจสอบ",
    "directory.evidence.local": "บริการเฉพาะพื้นที่",
    "directory.reviewed": "ตรวจทานล่าสุด",
    "directory.retrieved": "วันที่เก็บแหล่งข้อมูล",
    "directory.hours": "เวลาทำการ",
    "directory.source": "หน่วยงานและแหล่งข้อมูล",
    "directory.unavailable": "ยังไม่มีข้อมูล",
    "directory.limitations.draft":
      "หมายเลขและวัตถุประสงค์มีแหล่งอ้างอิง แต่ยังเป็นฉบับร่างและยังไม่ผ่านการอนุมัติเผยแพร่",
    "directory.limitations.review":
      "ยืนยันตัวเลขหรือหน่วยงานได้บางส่วน แต่ขอบเขตพื้นที่ กลุ่มผู้ใช้ หรือการให้บริการยังต้องตรวจทาน",
    "directory.limitations.local":
      "แหล่งข้อมูลรองรับเฉพาะพื้นที่ที่ระบุ ห้ามตีความว่าให้บริการทั่วประเทศ",
    "directory.category.immediate": "เหตุฉุกเฉินเร่งด่วน",
    "directory.category.medical": "การแพทย์และสุขภาพ",
    "directory.category.disaster": "ภัยพิบัติและสภาพอากาศ",
    "directory.category.fire": "ดับเพลิงและกู้ภัย",
    "directory.category.police": "ตำรวจและความปลอดภัยสาธารณะ",
    "directory.category.poison": "พิษและสารเคมี",
    "directory.category.utilities": "สาธารณูปโภค",
    "directory.category.road": "ถนนและการเดินทาง",
    "directory.category.social": "เด็ก ผู้สูงอายุ และสังคม",
    "directory.category.animal": "สัตว์และสัตว์เลี้ยง",
    "directory.category.local": "บริการท้องถิ่นและภูมิภาค",
    "page.home.eyebrow": "เริ่มต้นที่นี่",
    "page.home.title": "เลือกสิ่งที่ต้องการ",
    "page.home.body":
      "พื้นที่สำหรับเรียนรู้ภัยใกล้ตัว อุบัติเหตุ การปฐมพยาบาล สารเคมี ยา อาหาร และการเตรียมพร้อม ควบคู่กับทางเข้าความช่วยเหลือเมื่อจำเป็น เนื้อหาด้านความปลอดภัยยังอยู่ระหว่างการตรวจทาน",
    "page.home.tools": "เรื่องที่อยากรู้",
    "home.paths.title": "ทางเข้าใช้งานหลัก",
    "home.path.help.label": "ช่วยเหลือ",
    "home.path.help.title": "ต้องการความช่วยเหลือ",
    "home.path.help.body": "ดูหน้าจอฉุกเฉินตัวอย่าง ยังไม่มีคำแนะนำที่ผ่านการตรวจสอบ",
    "home.path.learn.label": "เรียนรู้",
    "home.path.learn.title": "เรียนรู้และเตรียมพร้อม",
    "home.path.learn.body": "สำรวจหมวดการเรียนรู้หลายด้าน เนื้อหาจริงจะเปิดเมื่อผ่านการตรวจทาน",
    "home.path.learn.action": "สำรวจหัวข้อ",
    "home.section.kicker": "เลือกดูตามหมวดหมู่",
    "home.categories.count": "9 หมวด",
    "home.secondary.kicker": "หัวข้ออื่น ๆ",
    "home.secondary.title": "สำรวจเพิ่มเติม",
    "learn.eyebrow": "สารบัญการเรียนรู้",
    "learn.title": "เรียนรู้เพื่อดูแลตัวเอง",
    "learn.body": "เลือกหัวข้อ อ่านสิ่งสำคัญก่อน แล้วเปิดดูวิธีเตรียมตัวและข้อควรระวังตามต้องการ",
    "learn.library.kicker": "คู่มือเรียนรู้เพื่อเตรียมพร้อม",
    "learn.library.title": "เลือกเรื่องที่อยากรู้และเตรียมตัว",
    "learn.library.boundary":
      "เนื้อหานี้ยังอยู่ระหว่างตรวจทาน สถานะแสดงบนแต่ละหัวข้อ และแหล่งข้อมูลอยู่ในหน้ารายละเอียด",
    "learn.library.diagnostic_count": "10 หัวข้อ",
    "learn.library.section_count": "8 ส่วนใช้งานจริง",
    "learn.library.detail_boundary":
      "ข้อมูลฉบับรอตรวจทาน ไม่ใช่คำสั่งฉุกเฉิน ให้ยึดประกาศและเจ้าหน้าที่ในพื้นที่จริง",
    "learn.library.contacts": "ค้นหาเบอร์ทางการในสมุดติดต่อ",
    "learn.library.filters": "กรองตามหมวด",
    "learn.library.search_label": "ค้นหาหัวข้อ",
    "learn.library.search_placeholder": "เช่น น้ำท่วม หรือการปฐมพยาบาล",
    "learn.library.category.all": "ทั้งหมด",
    "learn.library.category.hazards": "ภัยและสภาพแวดล้อม",
    "learn.library.category.health": "สุขภาพและผลิตภัณฑ์",
    "learn.library.category.preparedness": "การเตรียมพร้อม",
    "learn.library.category.public": "ความปลอดภัยสาธารณะ",
    "learn.library.status_label": "สถานะหัวข้อ",
    "learn.library.status.research_only": "RESEARCH ONLY",
    "learn.library.status.draft": "DRAFT",
    "learn.library.status.review_required": "ต้องตรวจทาน",
    "learn.library.status.available": "มีข้อมูลเมทาดาทา",
    "learn.library.status.coming_later": "เร็ว ๆ นี้",
    "learn.library.source": "ที่มาและการสืบค้น",
    "learn.library.source.thailand_dossier": "ชุดเอกสารแหล่งข้อมูลทางการของไทย (บันทึกค้นคว้า)",
    "learn.library.source.local_tools": "ข้อมูลเมทาดาทาจากเครื่องมือ Family Plan ในอุปกรณ์",
    "learn.library.source.thai_fda": "ระเบียนแหล่งข้อมูลจากสำนักงานคณะกรรมการอาหารและยา (อย.)",
    "learn.library.researched_label": "ค้นคว้าล่าสุด",
    "learn.library.provenance": "ที่มาและขอบเขต",
    "learn.library.publication": "สถานะการเผยแพร่",
    "learn.library.not_published": "ยังไม่เผยแพร่เป็นคำแนะนำ",
    "learn.library.empty.title": "ไม่พบหัวข้อในหมวดนี้",
    "learn.library.empty.body": "ลองเลือกหมวดอื่น ข้อมูลจะไม่สร้างคำแนะนำแทนเนื้อหาที่กำลังตรวจทาน",
    "learn.library.earthquake.title": "แผ่นดินไหว",
    "learn.library.earthquake.detail": "หลบให้ปลอดภัยระหว่างสั่น และระวังอาคารเสียหายหลังหยุดสั่น",
    "learn.library.tsunami.title": "สึนามิและการอพยพชายฝั่ง",
    "learn.library.tsunami.detail": "รู้สัญญาณธรรมชาติและทางไปพื้นที่สูงก่อนคลื่นมาถึง",
    "learn.library.flood.title": "น้ำท่วมและพายุ",
    "learn.library.flood.detail": "ติดตามคำเตือน เตรียมทางออก และเลี่ยงน้ำท่วม",
    "learn.library.fire.title": "ไฟไหม้และการอพยพอาคาร",
    "learn.library.fire.detail": "รู้ทางหนีไฟ ออกจากควัน และไม่กลับเข้าอาคาร",
    "learn.library.chemicals.title": "ความปลอดภัยของสารเคมีและผลิตภัณฑ์",
    "learn.library.chemicals.detail": "อ่านฉลาก เลี่ยงการสัมผัส และทำตามคำสั่งเฉพาะเหตุ",
    "learn.library.first_aid.title": "การปฐมพยาบาล",
    "learn.library.first_aid.detail":
      "สังเกตอาการเร่งด่วน เรียกความช่วยเหลือ และช่วยเท่าที่ปลอดภัย",
    "learn.library.public_safety.title": "ความปลอดภัยสาธารณะและเหตุคุกคาม",
    "learn.library.public_safety.detail": "ออกจากอันตรายหรือหาที่ซ่อนเมื่อออกไม่ได้",
    "learn.library.family.title": "การเตรียมพร้อมของครอบครัว",
    "learn.library.family.detail": "เตรียมผู้ติดต่อ จุดนัดพบ และข้อมูลจำเป็นของทุกคน",
    "learn.library.medicines.title": "ยา ฉลากยา และข้อมูลการใช้ยา",
    "learn.library.medicines.detail": "อ่านชื่อยา วิธีใช้ คำเตือน และถามผู้เชี่ยวชาญเมื่อไม่แน่ใจ",
    "learn.library.food_labels.title": "อาหาร ฉลาก และข้อมูลผู้แพ้อาหาร",
    "learn.library.food_labels.detail": "ตรวจส่วนประกอบ สารก่อภูมิแพ้ และวันหมดอายุก่อนกิน",
    "learn.detail.explanation": "เรื่องนี้คืออะไร",
    "learn.detail.why": "จำไว้",
    "learn.detail.scope": "เขตอำนาจและขอบเขต",
    "learn.detail.sources": "ระเบียนแหล่งข้อมูลทางการ",
    "learn.detail.sources_note": "ลิงก์ต่อไปนี้เป็นระเบียนแหล่งข้อมูลที่ใช้ประกอบการค้นคว้า",
    "learn.detail.gaps": "ช่องว่างและข้อจำกัดที่ทราบ",
    "learn.detail.research_only":
      "ฉบับรอตรวจทาน — ใช้เรียนรู้ ไม่แทนคำสั่งของเจ้าหน้าที่ในเหตุจริง",
    "learn.detail.category": "หมวด",
    "learn.detail.review": "สถานะการตรวจทาน",
    "learn.detail.earthquake.explanation":
      "แผ่นดินไหวคือการสั่นสะเทือนของพื้นดินที่อาจทำให้ของตก กระจกแตก และอาคารเสียหาย การป้องกันตัวระหว่างที่ยังสั่นจึงสำคัญกว่าการรีบวิ่งออกไป",
    "learn.detail.earthquake.why":
      "ถ้าอยู่ใกล้ชายฝั่ง ให้ดูหัวข้อสึนามิด้วย เพราะแผ่นดินไหวอาจมีความเสี่ยงต่อเนื่อง",
    "learn.detail.earthquake.scope":
      "ประเทศไทยจาก ปภ.; USGS ใช้เปรียบเทียบเชิงหลักการ ไม่ใช่นโยบายไทย",
    "learn.detail.earthquake.gaps":
      "ยังขาดแหล่งข้อมูลไทยฉบับปัจจุบันและการยืนยันเรื่องอาคารเสียหาย การอพยพ ผู้พิการ ยานพาหนะ และพื้นที่ชายฝั่ง",
    "learn.detail.tsunami.explanation":
      "สึนามิคือคลื่นทะเลขนาดใหญ่ที่อาจมาถึงชายฝั่งหลังแผ่นดินไหวหรือการรบกวนใต้ทะเล สัญญาณธรรมชาติอาจเกิดก่อนประกาศเตือน จึงต้องรู้ทางไปพื้นที่สูงไว้ล่วงหน้า",
    "learn.detail.tsunami.why":
      "ทางหนีภัยจริงขึ้นอยู่กับชายหาดและพื้นที่ที่คุณอยู่ ให้ดูป้ายอพยพในพื้นที่ไว้ล่วงหน้า",
    "learn.detail.tsunami.scope":
      "ชายฝั่งไทยที่อาจได้รับผลกระทบจากสึนามิจาก TMD; NOAA ใช้เป็นข้อมูลเปรียบเทียบทั่วไป",
    "learn.detail.tsunami.gaps":
      "ยังขาดเส้นทางจริง การอพยพแนวดิ่ง การเข้าถึงสำหรับทุกคน และช่องทางเตือนภัยปัจจุบันรายพื้นที่",
    "learn.detail.flood.explanation":
      "น้ำท่วม น้ำป่า และพายุอาจทำให้น้ำเพิ่มเร็ว ตัดเส้นทาง และเกิดอันตรายจากไฟฟ้าหรือน้ำปนเปื้อน การติดตามประกาศของพื้นที่ช่วยให้ตัดสินใจได้เร็วขึ้น",
    "learn.detail.flood.why":
      "น้ำท่วมฉับพลันเพิ่มเร็วได้ และถนนที่เห็นว่ายังผ่านได้อาจมีน้ำลึกหรือไหลแรง",
    "learn.detail.flood.scope":
      "ประเทศไทยจาก ปภ. และกรมอนามัย; NWS ใช้เปรียบเทียบข้อมูลทั่วไปของสหรัฐฯ",
    "learn.detail.flood.gaps":
      "ยังต้องแยกเกณฑ์ตามพื้นที่ น้ำท่วมฉับพลัน ระบบไฟฟ้า การเดินทาง และแผนอพยพก่อนเผยแพร่",
    "learn.detail.fire.explanation":
      "ไฟไหม้อาคารทำให้เกิดทั้งความร้อน ควัน และก๊าซอันตราย เป้าหมายหลักคือออกจากอาคารตามทางหนีไฟและไปรวมตัวในจุดปลอดภัย",
    "learn.detail.fire.why": "รู้ทางออกของอาคารที่อยู่ประจำไว้ก่อน เพราะควันอาจทำให้มองทางไม่ชัด",
    "learn.detail.fire.scope":
      "การอพยพอาคารในประเทศไทยจาก ปภ.; USFA ใช้เปรียบเทียบการวางแผนทั่วไปของสหรัฐฯ",
    "learn.detail.fire.gaps":
      "ยังขาดแหล่งข้อมูลไทยฉบับปัจจุบันตามประเภทอาคารและการยืนยันขอบเขตที่ไม่ครอบคลุมการดับเพลิง",
    "learn.detail.chemicals.explanation":
      "สารเคมีอาจเข้าสู่ร่างกายทางการหายใจ ผิวหนัง ดวงตา หรือการกลืน วิธีรับมือขึ้นกับชนิดสาร จึงต้องใช้ฉลาก เอกสาร SDS และคำสั่งของเจ้าหน้าที่เป็นหลัก",
    "learn.detail.chemicals.why":
      "ชื่อสารและวิธีสัมผัสมีผลต่อการช่วยเหลือ อย่าเดาวิธีจัดการจากเหตุของสารชนิดอื่น",
    "learn.detail.chemicals.scope":
      "ข้อมูลสาธารณสุขไทยจากกรมอนามัย; CDC ใช้เปรียบเทียบข้อมูลทั่วไปของสหรัฐฯ",
    "learn.detail.chemicals.gaps":
      "ยังขาดข้อมูลเฉพาะสาร เอกสาร SDS ช่องทางสัมผัส และขอบเขตการดูแลทางการแพทย์",
    "learn.detail.first_aid.explanation":
      "การปฐมพยาบาลคือการช่วยเบื้องต้นระหว่างรอผู้เชี่ยวชาญ โดยเริ่มจากความปลอดภัยของจุดเกิดเหตุ การเรียกความช่วยเหลือ และการทำเฉพาะสิ่งที่ผู้ช่วยทำได้อย่างปลอดภัย",
    "learn.detail.first_aid.why":
      "ผู้บาดเจ็บแต่ละคนต้องการความช่วยเหลือต่างกัน โดยเฉพาะเด็ก ทารก และผู้หมดสติ",
    "learn.detail.first_aid.scope":
      "ประเทศไทยจากสภากาชาดไทยและ สพฉ. โดยเอกสารมีบริบทการฝึกอบรมและบริการฉุกเฉินต่างกัน",
    "learn.detail.first_aid.gaps":
      "ยังต้องยืนยันฉบับแนวปฏิบัติปัจจุบัน กลุ่มเป้าหมาย และขอบเขตทางคลินิกก่อนเผยแพร่",
    "learn.detail.public_safety.explanation":
      "เหตุคุกคามสาธารณะอาจเปลี่ยนเร็วและไม่มีวิธีเดียวที่ใช้ได้ทุกสถานที่ หลักสำคัญสำหรับพลเรือนคือออกจากอันตรายเมื่อทำได้ หรือหาที่ซ่อนที่ปลอดภัยเมื่อออกไม่ได้",
    "learn.detail.public_safety.why":
      "ทางออกที่ปลอดภัยขึ้นอยู่กับสถานที่และตำแหน่งของภัย ให้ทำตามเจ้าหน้าที่เมื่อเข้าถึงได้",
    "learn.detail.public_safety.scope":
      "หน้าข้อมูลตำรวจไทยระดับพื้นที่และข้อมูลเปรียบเทียบจาก CISA สหรัฐฯ; ไม่ใช่ประกาศนโยบายระดับชาติของไทย",
    "learn.detail.public_safety.gaps":
      "ยังขาดแหล่งกลางของตำรวจไทย การยืนยันวันที่/ขอบเขต และการตรวจทานด้านจิตใจและความเหมาะสมกับบริบทไทย",
    "learn.detail.family.explanation":
      "แผนครอบครัวช่วยให้ทุกคนรู้ว่าจะติดต่อใคร นัดพบที่ไหน และต้องเตรียมอะไรเมื่อแยกจากกัน ข้อมูลใน SafeSphere เก็บไว้ในอุปกรณ์และไม่ต้องมีบัญชี",
    "learn.detail.family.why":
      "ถ้าโทรศัพท์หรืออินเทอร์เน็ตใช้ไม่ได้ คนในบ้านยังควรรู้จุดนัดพบและผู้ติดต่อสำรอง",
    "learn.detail.family.scope":
      "ฟังก์ชัน Family Plan ในอุปกรณ์ของ SafeSphere เท่านั้น ไม่ได้อ้างขอบเขตบริการสาธารณะหรือระดับประเทศ",
    "learn.detail.family.gaps":
      "ยังต้องตรวจทานความเหมาะสมกับบริบทไทย ความต้องการเฉพาะบุคคล และคำแนะนำของหน่วยงานในแต่ละพื้นที่ก่อนเผยแพร่",
    "learn.detail.medicines.explanation":
      "ฉลากยาช่วยยืนยันชื่อยา ความแรง วิธีใช้ คำเตือน วันหมดอายุ และการเก็บรักษา การอ่านทุกครั้งช่วยลดความเสี่ยงหยิบผิดหรือใช้ไม่ตรงคำสั่ง",
    "learn.detail.medicines.why":
      "ยาชื่อคล้ายกันอาจมีความแรงต่างกัน อ่านฉลากของขวดหรือแผงที่กำลังจะใช้ทุกครั้ง",
    "learn.detail.medicines.scope":
      "เอกสารสำหรับผู้บริโภคจาก อย. ประเทศไทย; ไม่ใช่คำปรึกษาเฉพาะบุคคลหรือคำสั่งจากผู้สั่งใช้ยา",
    "learn.detail.medicines.gaps":
      "ยังไม่มีการตรวจทานเรื่องปฏิกิริยาระหว่างยา อาหาร สมุนไพร ผลิตภัณฑ์เสริมอาหาร กลุ่มเสี่ยง และขอบเขตการส่งต่อ",
    "learn.detail.food_labels.explanation":
      "ฉลากอาหารบอกส่วนประกอบ สารก่อภูมิแพ้ วันหมดอายุ และเงื่อนไขการเก็บ ข้อมูลเหล่านี้ช่วยให้ผู้บริโภคหลีกเลี่ยงสิ่งที่ไม่เหมาะกับตนเอง",
    "learn.detail.food_labels.why":
      "ส่วนประกอบอาจเปลี่ยนได้ แม้เป็นอาหารยี่ห้อเดิม จึงควรอ่านฉลากทุกครั้ง",
    "learn.detail.food_labels.scope":
      "ข้อกำหนดและคำถามพบบ่อยของกองอาหาร อย. ประเทศไทย; ไม่ใช่รายการอาหารปลอดภัยสำหรับแต่ละบุคคล",
    "learn.detail.food_labels.gaps":
      "ยังไม่มีการตรวจทานคำแนะนำเฉพาะรายเรื่องการแพ้อาหาร การปนเปื้อนข้าม การจัดเก็บ หรือข้อจำกัดทางการแพทย์",
    "learn.detail.everyday.explanation":
      "ระเบียนภาพรวมนี้เชื่อมแหล่งข้อมูลทางการเกี่ยวกับความเสี่ยงจากผลิตภัณฑ์ในบ้านและการอ่านฉลาก โดยไม่สรุปเป็นขั้นตอนรับมือ",
    "learn.detail.everyday.why":
      "ความเสี่ยงใกล้ตัวมีหลายชนิดและต้องอาศัยบริบทของผลิตภัณฑ์ สถานที่ และบุคคล",
    "learn.detail.everyday.scope":
      "แหล่งข้อมูลกรมอนามัยและ อย. ประเทศไทยสำหรับการจัดหมวดงานค้นคว้าเท่านั้น",
    "learn.detail.everyday.gaps":
      "ยังขาดการแบ่งประเภทอุบัติเหตุในบ้าน ไฟฟ้า การลื่นล้ม เด็ก ผู้สูงอายุ และการตรวจทานโดยผู้เชี่ยวชาญเฉพาะด้าน",
    "learn.detail.accidents.explanation":
      "ระเบียนนี้จัดแหล่งข้อมูลการปฐมพยาบาลและระบบการแพทย์ฉุกเฉินไว้สำหรับร่างหัวข้ออุบัติเหตุ โดยไม่แสดงวิธีรักษา",
    "learn.detail.accidents.why":
      "คำแนะนำเรื่องอุบัติเหตุอาจมีผลต่อสุขภาพโดยตรงและต้องแยกตามชนิดเหตุและกลุ่มผู้ใช้",
    "learn.detail.accidents.scope":
      "เอกสารสภากาชาดไทยและ สพฉ. ใช้เป็นฐานค้นคว้าสำหรับประเทศไทยเท่านั้น",
    "learn.detail.accidents.gaps":
      "ยังต้องมีแพทย์หรือผู้ฝึกอบรมปฐมพยาบาลตรวจขอบเขต การส่งต่อ และถ้อยคำทุกประเภทเหตุ",
    "learn.detail.practical.explanation":
      "ฉบับร่างนี้อธิบายเฉพาะเครื่องมือจัดข้อมูลและหมวดการเตรียมพร้อม ไม่กำหนดรายการสิ่งของหรือขั้นตอนฉุกเฉิน",
    "learn.detail.practical.why":
      "การจัดข้อมูลล่วงหน้าช่วยให้ผู้ใช้ทบทวนความพร้อมของตนเอง แต่ไม่ควรถูกตีความเป็นคำแนะนำสากล",
    "learn.detail.practical.scope":
      "เครื่องมือ Family Plan ในอุปกรณ์และเอกสารภาพรวมของ ปภ.; ไม่มีการอ้างว่าเป็นแผนทางการเฉพาะครัวเรือน",
    "learn.detail.practical.gaps":
      "รายการเตรียมพร้อมยังต้องตรวจตามบริบทครัวเรือน ผู้พึ่งพิง สัตว์เลี้ยง ยา เอกสาร และพื้นที่",
    "learn.detail.disasters.explanation":
      "ระเบียนภาพรวมนี้เชื่อมไปยังงานค้นคว้าภัยแต่ละประเภท โดยไม่รวมภัยหลายชนิดเป็นคำแนะนำชุดเดียว",
    "learn.detail.disasters.why":
      "ภัยแต่ละชนิดมีระบบเตือนภัย พื้นที่ และเกณฑ์ตัดสินใจต่างกัน จึงต้องทบทวนแยกหัวข้อ",
    "learn.detail.disasters.scope": "ข้อมูลภาพรวมจาก ปภ. และกรมอุตุนิยมวิทยาสำหรับบริบทประเทศไทย",
    "learn.detail.disasters.gaps":
      "ยังไม่มีเนื้อหาที่ผู้เชี่ยวชาญอนุมัติสำหรับเส้นทางอพยพ จุดปลอดภัย หรือการตัดสินใจเฉพาะพื้นที่",
    "learn.detail.outdoors.explanation":
      "ระเบียนภาพรวมนี้แบ่งงานค้นคว้าสภาพแวดล้อมกลางแจ้งเป็นป่า/ภูเขา ทะเล/ชายฝั่ง และอากาศหนาว โดยไม่สอนการเอาชีวิตรอด",
    "learn.detail.outdoors.why":
      "ภูมิประเทศ อากาศ อุปกรณ์ และการเข้าถึงหน่วยช่วยเหลือแตกต่างกันมาก",
    "learn.detail.outdoors.scope":
      "แหล่งข้อมูลภาพรวมจาก ปภ. และกรมอุตุนิยมวิทยา; ยังไม่ใช่คู่มือภาคสนาม",
    "learn.detail.outdoors.gaps":
      "ยังขาดแหล่งเฉพาะสภาพแวดล้อม ผู้เชี่ยวชาญภาคสนาม ขอบเขตการแพทย์ และการยืนยันตามพื้นที่",
    "learn.detail.outdoors_forest.explanation":
      "ฉบับร่างนี้เก็บเฉพาะขอบเขตการค้นคว้าเรื่องป่าและภูเขา ไม่แสดงวิธีนำทาง หาอาหาร ก่อไฟ หรือปฐมพยาบาล",
    "learn.detail.outdoors_forest.why":
      "สภาพภูมิประเทศ อากาศ และระยะถึงหน่วยช่วยเหลือทำให้คำแนะนำทั่วไปอาจไม่เหมาะสม",
    "learn.detail.outdoors_forest.scope":
      "บริบทประเทศไทยในระดับภาพรวมจาก ปภ. และข้อมูลอากาศจากกรมอุตุนิยมวิทยา",
    "learn.detail.outdoors_forest.gaps":
      "ต้องมีผู้เชี่ยวชาญป่า/ภูเขา การค้นหาและกู้ภัย และเวชศาสตร์พื้นที่ทุรกันดารตรวจทานก่อนเผยแพร่",
    "learn.detail.outdoors_sea.explanation":
      "ฉบับร่างนี้เก็บขอบเขตการค้นคว้าทะเลและชายฝั่ง ไม่แสดงวิธีว่ายน้ำ เดินเรือ หรือเอาชีวิตรอดในน้ำ",
    "learn.detail.outdoors_sea.why":
      "คลื่น กระแสน้ำ เรือ อากาศ และระบบช่วยเหลือแตกต่างตามพื้นที่และเวลา",
    "learn.detail.outdoors_sea.scope":
      "ชายฝั่งและน่านน้ำไทยในระดับภาพรวม โดยยังไม่อ้างขั้นตอนปฏิบัติการทางทะเล",
    "learn.detail.outdoors_sea.gaps":
      "ต้องมีผู้เชี่ยวชาญทางทะเล หน่วยค้นหาและกู้ภัย และแหล่งเตือนภัยรายพื้นที่ตรวจทาน",
    "learn.detail.outdoors_cold.explanation":
      "ฉบับร่างนี้เก็บขอบเขตการค้นคว้าอากาศหนาวจัดและการเดินทาง โดยไม่แสดงการรักษาหรือเทคนิคเอาชีวิตรอด",
    "learn.detail.outdoors_cold.why":
      "ความหนาว ลม ความเปียกชื้น ระดับความสูง และสุขภาพส่วนบุคคลมีผลต่อความเสี่ยง",
    "learn.detail.outdoors_cold.scope":
      "ข้อมูลอากาศและภัยในระดับภาพรวม ไม่ใช่คู่มือพายุหิมะหรือเวชศาสตร์ความหนาว",
    "learn.detail.outdoors_cold.gaps":
      "ยังขาดแหล่งทางการไทยเฉพาะทางและการตรวจจากนักอุตุนิยมวิทยา เวชศาสตร์ และผู้เชี่ยวชาญภูเขา",
    "learn.topics_label": "หมวดการเรียนรู้",
    "learn.status": "รอตรวจทานเนื้อหา",
    "learn.unavailable":
      "หัวข้อนี้ยังไม่มีคำแนะนำที่อนุมัติให้เผยแพร่ จึงยังไม่แสดงขั้นตอนด้านความปลอดภัย",
    "learn.back": "กลับไปสารบัญ",
    "learn.return_to_index": "กลับไปสารบัญการเรียนรู้",
    "learn.everyday.title": "ภัยใกล้ตัว",
    "learn.everyday.detail": "ความเสี่ยงในบ้าน ที่ทำงาน และระหว่างเดินทาง",
    "learn.accidents.title": "อุบัติเหตุ",
    "learn.accidents.detail": "รู้จักเหตุไม่คาดคิดและการขอความช่วยเหลือ",
    "learn.first_aid.title": "การปฐมพยาบาล",
    "learn.first_aid.detail": "ความรู้พื้นฐานที่ต้องผ่านผู้เชี่ยวชาญตรวจทาน",
    "learn.practical.title": "ทริกและการเตรียมพร้อม",
    "learn.practical.detail": "นิสัยเล็ก ๆ และเครื่องมือที่ช่วยให้พร้อมขึ้น",
    "learn.outdoors.title": "การเอาชีวิตรอด",
    "learn.outdoors.detail": "เลือกสภาพแวดล้อมเพื่อดูหัวข้อที่เกี่ยวข้อง",
    "learn.outdoors.environments": "เลือกสภาพแวดล้อม",
    "learn.outdoors.back": "กลับไปเลือกสภาพแวดล้อม",
    "learn.outdoors.forest": "ป่าและภูเขา",
    "learn.outdoors.forest_detail": "การเดินทางและการติดค้างบนบก",
    "learn.outdoors.sea": "ทะเลและชายฝั่ง",
    "learn.outdoors.sea_detail": "การเดินทางทางน้ำและพื้นที่ชายฝั่ง",
    "learn.outdoors.cold": "หนาวจัดและพายุหิมะ",
    "learn.outdoors.cold_detail": "การเดินทางในอากาศหนาวจัด",
    "learn.disasters.title": "ภัยพิบัติ",
    "learn.disasters.detail": "ทำความเข้าใจเหตุการณ์และการเตรียมตัวล่วงหน้า",
    "learn.chemicals.title": "ผลิตภัณฑ์และสารเคมีในบ้าน",
    "learn.chemicals.detail": "ฉลาก ส่วนผสม การเก็บ และความเสี่ยงจากการใช้ร่วมกัน",
    "learn.chemicals.outline": "หัวข้อที่เตรียมตรวจทาน",
    "learn.chemicals.labels": "ฉลากและส่วนผสมของผลิตภัณฑ์",
    "learn.chemicals.storage": "การเก็บผลิตภัณฑ์ในบ้าน",
    "learn.chemicals.combinations": "การใช้ผลิตภัณฑ์ร่วมกัน",
    "learn.chemicals.exposure": "การขอความช่วยเหลือเมื่อสัมผัสสาร",
    "learn.chemicals.unknown":
      "ยังไม่มีระบบตรวจสอบการใช้สารร่วมกัน หากข้อมูลส่วนผสมไม่พอ ผลต้องเป็น ‘ไม่ทราบ’ ไม่ใช่ ‘ปลอดภัย’",
    "learn.medicines.title": "ยาและการใช้ร่วมกัน",
    "learn.medicines.detail": "ฉลากยา การใช้ยาร่วมกัน และความสัมพันธ์กับอาหาร",
    "learn.medicines.outline": "หัวข้อยาที่เตรียมตรวจทาน",
    "learn.medicines.labels": "ข้อมูลบนฉลากและชื่อสามัญยา",
    "learn.medicines.medicine_medicine": "การใช้ยาหลายชนิดร่วมกัน",
    "learn.medicines.medicine_food": "ยา อาหาร และเครื่องดื่ม",
    "learn.medicines.professional": "คำถามที่ควรส่งต่อให้เภสัชกรหรือแพทย์",
    "learn.medicines.unknown":
      "ยังไม่มีระบบตรวจสอบปฏิกิริยาระหว่างยา อย่าใช้หน้านี้ตัดสินใจเริ่ม หยุด หรือเปลี่ยนยา",
    "learn.food.title": "อาหารและความปลอดภัย",
    "learn.food.detail": "ฉลาก สารก่อภูมิแพ้ การเก็บอาหาร และข้อควรระวังในการบริโภค",
    "learn.food.outline": "หัวข้ออาหารที่เตรียมตรวจทาน",
    "learn.food.labels": "ข้อมูลบนฉลากอาหาร",
    "learn.food.allergens": "สารก่อภูมิแพ้และข้อจำกัดเฉพาะบุคคล",
    "learn.food.storage": "การเก็บและการปนเปื้อนของอาหาร",
    "learn.food.interactions": "อาหาร เครื่องดื่ม และยาที่ใช้อยู่",
    "learn.food.unknown":
      "หน้านี้ยังไม่ประเมินความปลอดภัยของอาหารหรือการใช้ร่วมกับยา ข้อมูลไม่พอต้องแสดงว่า ‘ไม่ทราบ’",
    "home.area.disaster": "เส้นทางตัวอย่างสำหรับฝึกใช้งาน",
    "home.area.contacts": "ค้นหาเบอร์บริการตามประเภทและพื้นที่ พร้อมดูสถานะการตรวจทาน",
    "home.area.search": "ค้นหาข้อมูลที่บันทึกในอุปกรณ์",
    "home.area.family": "จัดการแผนที่เก็บไว้ในอุปกรณ์",
    "home.area.readiness.title": "ความพร้อมออฟไลน์",
    "home.area.readiness.body": "ตรวจสิ่งที่พร้อมใช้งานบนอุปกรณ์",
    "home.utilities.kicker": "เครื่องมือในอุปกรณ์",
    "home.utilities.title": "เตรียมไว้ ใช้ได้แม้ออฟไลน์",
    "home.utilities.action": "เปิดส่วนนี้",
    "page.emergency.eyebrow": "ทางเข้าด่วน",
    "page.emergency.title": "โหมดฉุกเฉิน",
    "page.emergency.body":
      "พื้นที่อ่านข้อมูลติดต่อฉบับรอตรวจ และทดลองเส้นทางใช้งานที่กระชับ เข้าถึงง่าย",
    "page.disaster.eyebrow": "การเตรียมพร้อม",
    "page.disaster.title": "ภัยพิบัติ",
    "page.disaster.body": "รวมหัวข้อภัยพิบัติที่กำลังจัดเตรียมเพื่อการตรวจสอบและเผยแพร่แบบออฟไลน์",
    "disaster.index.kicker": "สารบัญหัวข้อ",
    "disaster.index.title": "เตรียมเนื้อหาอย่างมีที่มา",
    "disaster.index.body":
      "แต่ละหัวข้อจะเปิดเมื่อมีแหล่งอ้างอิง การตรวจภาษา และการอนุมัติครบถ้วนเท่านั้น",
    "disaster.draft.title": "สารบัญภัยพิบัติฉบับค้นคว้า",
    "disaster.draft.body":
      "หน้ารวมนี้เชื่อมไปยังข้อมูลค้นคว้าของแต่ละภัย เพื่ออ่านที่มา ขอบเขต และสิ่งที่ยังไม่ทราบ โดยยังไม่แสดงขั้นตอนฉุกเฉิน",
    "disaster.draft.scope":
      "หัวข้อสำหรับประเทศไทยจากแหล่ง ปภ. กรมอุตุนิยมวิทยา และหน่วยงานทางการที่ระบุในแต่ละหน้า",
    "disaster.draft.source": "คู่มือเตรียมพร้อมภัยพิบัติสำหรับประชาชนของ ปภ.",
    "disaster.draft.limitations":
      "เส้นทางอพยพ จุดปลอดภัย เกณฑ์ตัดสินใจเฉพาะพื้นที่ และคำแนะนำความเสี่ยงสูงยังรอผู้เชี่ยวชาญตรวจ",
    "disaster.topic.earthquake": "แผ่นดินไหว",
    "disaster.topic.earthquake_detail": "หัวข้อการรับรู้สถานการณ์และการเตรียมตัว",
    "disaster.topic.flood": "น้ำท่วมและพายุ",
    "disaster.topic.flood_detail": "หัวข้อสภาพอากาศ น้ำ และการเตรียมแผน",
    "disaster.topic.coast": "ชายฝั่งและคลื่นทะเล",
    "disaster.topic.coast_detail": "หัวข้อสัญญาณเตือนและการเตรียมตัวในพื้นที่ชายฝั่ง",
    "disaster.topic.fire": "ไฟไหม้และการอพยพอาคาร",
    "disaster.topic.fire_detail": "หัวข้อการป้องกันและการออกจากพื้นที่อย่างปลอดภัย",
    "page.search.eyebrow": "ค้นหาในอุปกรณ์",
    "page.search.title": "ค้นหา",
    "page.search.body":
      "ค้นหาเนื้อหาที่พร้อมใช้งานบนอุปกรณ์นี้ และตรวจสถานะของแต่ละรายการก่อนนำไปใช้",
    "page.family.eyebrow": "ข้อมูลส่วนตัว",
    "page.family.title": "แผนครอบครัว",
    "page.family.body":
      "วางข้อมูลสำคัญของครอบครัวไว้ในอุปกรณ์นี้ เพื่อเปิดดูและเตรียมพร้อมได้แม้ออฟไลน์",
    "page.settings.eyebrow": "การตั้งค่า",
    "page.settings.title": "ตั้งค่า",
    "page.settings.body": "ปรับภาษาที่ใช้แสดงผลบนอุปกรณ์นี้",
    "build.stage": "รุ่นทดสอบก่อนเผยแพร่",
    "build.stage_short": "TESTING",
    "build.title": "ข้อมูลรุ่นทดสอบ",
    "build.body": "ใช้สำหรับตรวจสอบ staging และอุปกรณ์จริง ยังไม่ใช่รุ่นเผยแพร่สาธารณะ",
    "build.version": "เวอร์ชันแอป",
    "build.date": "วันที่สร้าง",
    "build.bundle": "ชุดเนื้อหาที่ใช้งาน",
    "build.bundle_none": "ยังไม่มีชุดเนื้อหาที่ตรวจสอบแล้วในภาษานี้",
    "build.contacts_date": "วันที่ข้อมูลรายชื่อติดต่อ",
    "about.eyebrow": "ABOUT SAFESPHERE",
    "about.title": "รู้เท่าทัน ดูแลตัวเอง และเตรียมพร้อม",
    "about.body":
      "SafeSphere คือพื้นที่เรียนรู้แบบกระชับสำหรับเรื่องใกล้ตัว เหตุไม่คาดคิด และการเตรียมพร้อมในชีวิตประจำวัน",
    "about.purpose_title": "สิ่งที่เราตั้งใจทำ",
    "about.purpose_body":
      "ทำให้เรื่องสำคัญอ่านง่าย เห็นภาพ และกลับมาเปิดทบทวนได้เมื่อจำเป็น โดยแยกเนื้อหาการเรียนรู้ออกจากเส้นทางขอความช่วยเหลือให้ชัดเจน",
    "about.books_eyebrow": "COMING LATER",
    "about.books_title": "หนังสือและไฟล์เรียนรู้",
    "about.books_body": "พื้นที่สำหรับหนังสือและไฟล์เสริมจะเพิ่มในภายหลัง",
    "about.footer_link": "About SafeSphere",
    "support.eyebrow": "SAFE TO SKIP",
    "support.title": "สนับสนุน SafeSphere",
    "support.body":
      "SafeSphere ใช้งานแกนหลักได้ฟรีเสมอ หากอยากช่วยสนับสนุนงานออกแบบและการดูแลเนื้อหา สามารถให้กำลังใจได้ที่ Ko-fi",
    "support.action": "สนับสนุนผ่าน Ko-fi",
    "support.footer_link": "Support SafeSphere ↗",
    "placeholder.label": "ตัวอย่างโครงสร้าง",
    "placeholder.not_guidance": "ส่วนนี้ยังไม่มีคำแนะนำด้านความปลอดภัย",
    "disaster.loading": "กำลังกู้คืนขั้นตอนที่บันทึกไว้…",
    "disaster.fixture_badge": "โหมดทดสอบ — ไม่มีคำแนะนำจริง",
    "disaster.progress": "ขั้นตอน",
    "disaster.entry.title": "เริ่มโหมดภัยพิบัติจำลอง",
    "disaster.entry.body":
      "ขั้นตอนนี้ใช้ข้อความสมมติเพื่อทดสอบการนำทางและการกู้คืนเท่านั้น ไม่ใช่คำแนะนำด้านความปลอดภัย",
    "disaster.start": "เริ่มขั้นตอนจำลอง",
    "disaster.step.event": "กำลังเกิดเหตุการณ์สมมติใด",
    "disaster.body.event": "เลือกเหตุการณ์ทดสอบหนึ่งรายการ",
    "disaster.choice.event_a": "เหตุการณ์สมมติ อัลฟา",
    "disaster.choice.event_b": "เหตุการณ์สมมติ เบตา",
    "disaster.step.context": "คุณอยู่ในบริบทจำลองใด",
    "disaster.body.context": "เลือกประเภทสถานที่ทดสอบหนึ่งรายการ",
    "disaster.choice.indoor": "พื้นที่จำลองภายใน",
    "disaster.choice.outdoor": "พื้นที่จำลองภายนอก",
    "disaster.step.danger": "มีเงื่อนไขอันตรายจำลองทันทีหรือไม่",
    "disaster.body.danger": "คำตอบนี้ใช้ทดสอบสาขาของระบบเท่านั้น",
    "disaster.choice.danger_yes": "มี — เงื่อนไขทดสอบ",
    "disaster.choice.danger_no": "ไม่มี — เงื่อนไขทดสอบ",
    "disaster.step.decision": "เลือกสาขาการตัดสินใจจำลอง",
    "disaster.body.decision": "ตัวเลือกเหล่านี้ไม่มีคำแนะนำให้ปฏิบัติจริง",
    "disaster.choice.branch_a": "สาขาจำลอง A",
    "disaster.choice.branch_b": "สาขาจำลอง B",
    "disaster.step.action": "หน้าการกระทำจำลองถัดไป",
    "disaster.body.action":
      "หน้าจอนี้จะแสดงเฉพาะเนื้อหาที่ผ่านการตรวจสอบและผูกกับชุดข้อมูลที่เชื่อถือได้",
    "disaster.choice.acknowledge": "รับทราบข้อความตัวอย่าง",
    "disaster.step.continuation": "หลังเหตุการณ์จำลอง",
    "disaster.body.continuation": "เลือกว่าจะไปยังหน้าต่อเนื่องหรือสิ้นสุดการทดสอบ",
    "disaster.choice.continue": "ไปยังหน้าต่อเนื่องจำลอง",
    "disaster.choice.finish": "สิ้นสุดขั้นตอนจำลอง",
    "disaster.step.complete": "ขั้นตอนจำลองเสร็จสมบูรณ์",
    "disaster.body.complete": "การทดสอบการนำทางเสร็จแล้ว ไม่มีคำแนะนำด้านความปลอดภัยถูกแสดง",
    "disaster.options": "ตัวเลือกสำหรับขั้นตอนนี้",
    "disaster.controls": "ส่วนควบคุมโหมดภัยพิบัติ",
    "disaster.back": "ย้อนกลับ",
    "disaster.restart": "เริ่มใหม่",
    "disaster.exit": "ออกจากโหมด",
    "disaster.diagnostics": "ข้อมูลสถานะสำหรับผู้พัฒนา",
    "disaster.diagnostics_state": "สถานะ",
    "disaster.diagnostics_events": "เหตุการณ์ที่อนุญาต",
    "disaster.diagnostics_history": "ประวัติการนำทาง",
    "binding.loading": "กำลังตรวจสอบเนื้อหาที่บันทึกไว้…",
    "binding.status.ready": "เนื้อหาสมมติที่ตรวจสอบแล้ว",
    "binding.status.stale": "เนื้อหาที่ตรวจสอบแล้ว แต่อาจเก่า",
    "binding.unavailable.title": "ไม่สามารถเปิดเนื้อหาสำหรับขั้นตอนนี้",
    "binding.reason.NO_ACTIVE_BUNDLE": "ไม่พบชุดเนื้อหาที่ตรวจสอบแล้วในอุปกรณ์นี้",
    "binding.reason.NO_KNOWN_GOOD_BUNDLE": "ไม่พบชุดเนื้อหาสำรองที่ใช้งานได้",
    "binding.reason.BUNDLE_UNTRUSTED": "ชุดเนื้อหาไม่ผ่านการตรวจสอบความน่าเชื่อถือ",
    "binding.reason.BUNDLE_SCHEMA_INVALID": "รูปแบบชุดเนื้อหาไม่รองรับหรือไม่สมบูรณ์",
    "binding.reason.LOCALE_MISMATCH": "ชุดเนื้อหาไม่ตรงกับภาษาที่เลือก",
    "binding.reason.PAYLOAD_INVALID": "ข้อมูลหน้าจอไม่สมบูรณ์",
    "binding.reason.STATE_MAPPING_MISSING": "ไม่พบเนื้อหาสำหรับขั้นตอนและเส้นทางนี้",
    "binding.reason.REVISION_MISSING": "ไม่พบรหัสฉบับเนื้อหา",
    "binding.reason.REVISION_MISMATCH": "ฉบับเนื้อหาไม่ตรงกับรายการที่ตรวจสอบแล้ว",
    "binding.reason.HASH_MISMATCH": "เนื้อหาไม่ตรงกับลายนิ้วมือของฉบับที่ตรวจสอบแล้ว",
    "binding.reason.PUBLICATION_INELIGIBLE": "เนื้อหานี้ยังไม่ผ่านเงื่อนไขการเผยแพร่",
    "binding.reason.RETIRED_OR_SUPERSEDED": "เนื้อหานี้ถูกยกเลิกหรือแทนที่แล้ว",
    "binding.return": "กลับไปขั้นตอนก่อนหน้า",
    "binding.use_known_good": "ใช้ชุดสำรองที่ตรวจสอบแล้ว",
    "binding.provenance": "แหล่งที่มา:",
    "binding.reviewed": "ตรวจทานล่าสุด:",
    "binding.diagnostics_bundle": "Bundle ID",
    "binding.diagnostics_locale": "ภาษา",
    "binding.diagnostics_revision": "Revision ID",
    "binding.diagnostics_eligibility": "ผลการตรวจสอบ",
    "library.loading": "กำลังเปิดดัชนีเนื้อหาที่ตรวจสอบแล้ว…",
    "library.unavailable_title": "ยังไม่มีคลังเนื้อหาที่ใช้งานได้",
    "library.unavailable_body": "ไม่พบชุดเนื้อหาที่ผ่านการตรวจสอบในภาษานี้",
    "library.search_title": "ค้นหาในอุปกรณ์",
    "library.query_label": "คำค้น",
    "library.query_placeholder": "ค้นหาหัวข้อ หมวดหมู่ หรือคำที่อนุมัติ",
    "library.browse": "เรียกดูเนื้อหา",
    "library.categories": "หมวดหมู่",
    "library.topics": "หัวข้อ",
    "library.all": "ทั้งหมด",
    "library.results": "ผลลัพธ์",
    "library.empty_title": "ไม่พบรายการที่ตรงกัน",
    "library.empty_body": "ลองใช้เฉพาะหัวข้อหรือหมวดหมู่ที่แสดงด้านล่าง",
    "library.matched_by": "ตรงจาก",
    "library.match.TITLE": "ชื่อเรื่อง",
    "library.match.TAXONOMY": "หัวข้อหรือหมวดหมู่",
    "library.match.ALIAS": "คำค้นที่อนุมัติ",
    "library.match.SUMMARY": "สรุป",
    "library.back": "กลับไปผลการค้นหา",
    "library.status": "สถานะเนื้อหา",
    "library.verified": "ตรวจสอบแล้ว",
    "library.stale": "ตรวจสอบแล้ว แต่อาจล้าสมัย",
    "library.topic": "หัวข้อ",
    "library.jurisdiction": "เขตอำนาจ",
    "library.provenance": "แหล่งที่มา",
    "library.reviewed": "ตรวจทานล่าสุด",
    "library.fixture_note": "ข้อมูลสมมติสำหรับทดสอบระบบเท่านั้น ไม่ใช่คำแนะนำด้านความปลอดภัย",
    "library.diagnostics": "ข้อมูลวินิจฉัยดัชนี",
    "library.bundle": "Bundle ID",
    "library.locale": "ภาษา",
    "library.record_count": "จำนวนรายการ",
    "library.generation": "รุ่นดัชนี",
    "library.source": "แหล่งชุดข้อมูล",
    "family.privacy.title": "ข้อมูลอยู่ในอุปกรณ์นี้",
    "family.privacy.body":
      "ไม่ต้องสมัครสมาชิกหรือเข้าสู่ระบบ ข้อมูลแผนทั่วไปเปิดดูได้รวดเร็ว ส่วนข้อมูลส่วนตัวจะเข้ารหัสและเปิดได้ด้วยรหัสผ่านที่คุณสร้างเท่านั้น",
    "family.privacy.fact.no_account": "ไม่ต้องสมัครสมาชิก",
    "family.privacy.fact.local": "เก็บในเบราว์เซอร์ของเครื่องนี้เท่านั้น",
    "family.privacy.fact.backup": "ส่งออกไฟล์สำรองเองก่อนเปลี่ยนเครื่อง",
    "family.privacy.warning": "หากลืมรหัสผ่าน แอปไม่สามารถกู้คืนข้อมูลในห้องนิรภัยได้",
    "family.tabs": "ส่วนต่าง ๆ ของแผนครอบครัว",
    "draft.status.RESEARCH_ONLY": "RESEARCH ONLY",
    "draft.status.DRAFT": "DRAFT",
    "draft.status.REVIEW_REQUIRED": "REVIEW REQUIRED",
    "draft.scope": "ขอบเขต",
    "draft.source": "ที่มา",
    "draft.researched": "วันที่จัดทำร่าง",
    "draft.limitations": "ข้อจำกัด",
    "family.draft.title": "ขอบเขตฉบับร่างของแผนครอบครัว",
    "family.draft.explanation":
      "ส่วนนี้เป็นเครื่องมือจัดข้อมูลในอุปกรณ์ ไม่ใช่แผนอพยพหรือคำแนะนำฉุกเฉินจากหน่วยงาน",
    "family.draft.scope":
      "ข้อมูลครัวเรือน จุดนัดพบ รายการเตรียมพร้อม Vault การ์ดสื่อสาร และข้อมูลสำรองในอุปกรณ์นี้",
    "family.draft.source": "ระเบียนการค้นคว้าการเตรียมพร้อมของครอบครัว",
    "family.draft.limitations":
      "ยังเป็นแผนตัวอย่างหนึ่งแผน ไม่มีบัญชีหรือการซิงก์ และรายการเตรียมพร้อมยังไม่ได้รับรองโดยผู้เชี่ยวชาญ",
    "family.tab.OVERVIEW": "ภาพรวม",
    "family.tab.CONTACTS": "ผู้ติดต่อ",
    "family.tab.MEETING": "จุดนัดพบ",
    "family.tab.CHECKLISTS": "รายการเตรียมพร้อม",
    "family.tab.VAULT": "ห้องนิรภัย",
    "family.tab.CARDS": "บัตรรวมตัวและสื่อสาร",
    "family.tab.BACKUP": "สำรองและกู้คืน",
    "family.empty": "ยังไม่มีแผนครอบครัวในอุปกรณ์นี้",
    "family.load_fixture": "โหลดข้อมูลสมมติสำหรับทดสอบ",
    "family.plan_label": "ชื่อแผน",
    "family.contacts": "ผู้ติดต่อฉุกเฉิน",
    "family.contact_name": "ชื่อผู้ติดต่อสมมติ",
    "family.meeting_points": "จุดนัดพบ",
    "family.meeting_label": "ชื่อจุดนัดพบสมมติ",
    "family.checklists": "รายการตรวจสอบ",
    "family.vault.state_locked": "ห้องนิรภัยล็อกอยู่",
    "family.vault.state_unlocked": "ห้องนิรภัยเปิดอยู่บนอุปกรณ์นี้ชั่วคราว",
    "family.vault.passphrase": "รหัสผ่านห้องนิรภัย",
    "family.vault.create": "สร้างห้องนิรภัย",
    "family.vault.unlock": "ปลดล็อก",
    "family.vault.lock": "ล็อกตอนนี้",
    "family.vault.short": "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร",
    "family.vault.created": "สร้างและเปิดห้องนิรภัยแล้ว",
    "family.vault.unlocked": "ปลดล็อกแล้ว",
    "family.vault.incorrect": "รหัสผ่านไม่ถูกต้องหรือข้อมูลห้องนิรภัยเสียหาย",
    "family.vault.locked": "ล็อกห้องนิรภัยแล้ว",
    "family.vault.kind.MEMBER": "ข้อมูลสมาชิกที่เข้ารหัส",
    "family.vault.kind.PET": "ข้อมูลสัตว์เลี้ยงที่เข้ารหัส",
    "family.vault.kind.PRIVATE_NOTE": "บันทึกส่วนตัวที่เข้ารหัส",
    "family.vault.records": "รายการในห้องนิรภัย",
    "family.backup.passphrase": "รหัสผ่านไฟล์สำรอง",
    "family.backup.export": "สร้างไฟล์สำรองเข้ารหัส",
    "family.backup.data": "ข้อมูลสำรองเข้ารหัส",
    "family.backup.preview": "ตรวจสอบก่อนนำเข้า",
    "family.backup.confirm": "ยืนยันนำเข้า",
    "family.backup.ready": "สร้างข้อมูลสำรองเข้ารหัสแล้ว",
    "family.backup.unlock_required": "ต้องปลดล็อกห้องนิรภัยและใช้รหัสผ่านอย่างน้อย 8 ตัวอักษร",
    "family.backup.preview_ready": "ตรวจสอบไฟล์แล้ว พร้อมยืนยันนำเข้า",
    "family.backup.imported": "นำเข้าและเข้ารหัสข้อมูลในอุปกรณ์นี้แล้ว",
    "family.backup.MALFORMED": "ไฟล์สำรองไม่ใช่ JSON ที่สมบูรณ์",
    "family.backup.INCOMPATIBLE": "รูปแบบหรือเวอร์ชันไฟล์สำรองไม่รองรับ",
    "family.backup.INCORRECT_PASSPHRASE": "รหัสผ่านไฟล์สำรองไม่ถูกต้อง",
    "family.backup.INVALID_DATA": "ข้อมูลภายในไฟล์สำรองไม่ผ่านการตรวจสอบ",
    "family.diagnostics": "ข้อมูลวินิจฉัยแบบไม่เปิดเผยข้อมูลส่วนตัว",
    "family.diagnostics_body":
      "ส่วนนี้แสดงเฉพาะสถานะและเวอร์ชัน ไม่แสดงชื่อ ข้อมูลสุขภาพ บันทึก หรือ ciphertext",
    "family.vault.status": "สถานะห้องนิรภัย",
    "family.plan_schema": "เวอร์ชัน schema",
    "cards.privacy_default":
      "เริ่มต้นโดยไม่เลือกข้อมูลใด เลือกเฉพาะข้อมูลที่จำเป็นและตรวจตัวอย่างก่อนแชร์ทุกครั้ง",
    "cards.choose_type": "ประเภทบัตร",
    "cards.kind.FAMILY_STATUS": "สถานะครอบครัว",
    "cards.kind.OUT_OF_AREA_CONTACT": "ผู้ติดต่อนอกพื้นที่",
    "cards.kind.MEETING_POINT": "สรุปจุดนัดพบ",
    "cards.kind.CHILD_SUPPORT": "การช่วยเหลือเด็ก",
    "cards.kind.OLDER_ADULT_SUPPORT": "การช่วยเหลือผู้สูงอายุ",
    "cards.kind.PET_REUNIFICATION": "การรวมตัวสัตว์เลี้ยง",
    "cards.kind.COMMUNICATION_TEMPLATE": "ข้อความสื่อสาร",
    "cards.quick_fields": "ข้อมูลแผนทั่วไปที่ต้องการแสดง",
    "cards.protected_fields": "ข้อมูลจากห้องนิรภัย",
    "cards.unlock_required": "ปลดล็อกห้องนิรภัยในแท็บก่อนหน้าเพื่อเลือกข้อมูลส่วนตัว",
    "cards.sensitive_confirm": "ฉันยืนยันว่าข้อมูลที่เลือกจะมองเห็นได้ในบัตรที่ส่งออกหรือแชร์",
    "cards.confirm_required": "ต้องยืนยันการมองเห็นข้อมูลส่วนตัวก่อนสร้างตัวอย่าง",
    "cards.template_choose": "เลือกข้อความสมมติ",
    "cards.template_edit": "แก้ไขข้อความก่อนสร้างตัวอย่าง",
    "cards.template.I_AM_SAFE": "ฉันปลอดภัย",
    "cards.template.MOVING_TO_MEETING_POINT": "กำลังไปจุดนัดพบ",
    "cards.template.CONTACT_THIS_PERSON": "โปรดติดต่อบุคคลนี้",
    "cards.template.NEED_ASSISTANCE": "ต้องการความช่วยเหลือ",
    "cards.template.WE_ARE_SEPARATED": "เราแยกกันอยู่",
    "cards.preview": "สร้างตัวอย่างบัตร",
    "cards.fixture": "ข้อมูลสมมติสำหรับทดสอบเท่านั้น",
    "cards.visibility.SUITABLE_TO_SHARE": "เหมาะสำหรับแชร์หลังตรวจสอบ",
    "cards.visibility.PRIVATE_DEVICE_ONLY": "ส่วนตัว — ควรเก็บไว้ในอุปกรณ์",
    "cards.visibility.INCLUDES_SENSITIVE": "มีข้อมูลส่วนตัวที่ผู้ใช้ยืนยันให้แสดง",
    "cards.copy": "คัดลอกข้อความ",
    "cards.share": "เปิดเมนูแชร์",
    "cards.export_text": "ส่งออกไฟล์ข้อความ",
    "cards.print": "เปิดหน้าพิมพ์",
    "cards.action.COPIED": "คัดลอกไว้ในอุปกรณ์แล้ว",
    "cards.action.SHARED": "เปิดเมนูแชร์แล้ว ไม่มีการส่งอัตโนมัติ",
    "cards.action.COPIED_FALLBACK": "อุปกรณ์ไม่มีเมนูแชร์ จึงคัดลอกข้อความแทน",
    "cards.action.UNAVAILABLE": "อุปกรณ์นี้ไม่รองรับการทำงานนี้",
    "cards.action.EXPORTED": "สร้างไฟล์ข้อความในอุปกรณ์แล้ว",
    "update.eyebrow": "อัปเดตเนื้อหาแบบตรวจสอบได้",
    "update.title": "ตรวจหาและติดตั้งชุดเนื้อหา",
    "update.body": "เนื้อหาที่บันทึกไว้ยังใช้งานได้เสมอ หากเครือข่ายหรือการอัปเดตมีปัญหา",
    "update.state.IDLE": "พร้อมตรวจหาอัปเดต",
    "update.state.CHECKING": "กำลังตรวจหาอัปเดต…",
    "update.state.UP_TO_DATE": "เนื้อหาที่บันทึกไว้เป็นเวอร์ชันล่าสุด",
    "update.state.DOWNLOADING": "กำลังดาวน์โหลดไปยังพื้นที่พัก…",
    "update.state.VERIFYING": "ตรวจสอบแล้ว พร้อมยืนยันการเปิดใช้งาน",
    "update.state.ACTIVATED": "เปิดใช้งานชุดเนื้อหาที่ตรวจสอบแล้ว",
    "update.state.FAILED": "อัปเดตไม่สำเร็จ ยังใช้เนื้อหาที่บันทึกไว้",
    "update.bundle": "Bundle ID",
    "update.version": "เวอร์ชัน",
    "update.locale": "ภาษา",
    "update.key": "Signing key",
    "update.check": "ตรวจหาอัปเดต",
    "update.download": "ดาวน์โหลดและตรวจสอบ",
    "update.retry": "ลองดาวน์โหลดอีกครั้ง",
    "update.activate": "เตรียมเปิดใช้งาน",
    "update.rollback": "กลับไปใช้ชุดสำรอง",
    "update.confirm_title": "ยืนยันการเปลี่ยนชุดเนื้อหา",
    "update.confirm_activate":
      "ยืนยันใช้ชุดที่ผ่านการตรวจสอบนี้หรือไม่ ชุดปัจจุบันจะถูกเก็บเป็นชุดสำรอง",
    "update.confirm_rollback": "ยืนยันกลับไปใช้ชุดสำรองที่ผ่านการตรวจสอบหรือไม่",
    "update.confirm": "ยืนยัน",
    "update.cancel": "ยกเลิก",
    "update.reason.INDEX_UNAVAILABLE": "ติดต่อรายการอัปเดตไม่ได้ ยังใช้เนื้อหาที่บันทึกไว้",
    "update.reason.INVALID_INDEX": "รายการอัปเดตมีรูปแบบไม่ถูกต้อง",
    "update.reason.NO_UPDATE": "ไม่มีอัปเดตสำหรับภาษานี้",
    "update.reason.DOWNLOAD_INTERRUPTED": "การดาวน์โหลดหยุดกลางคัน สามารถลองใหม่ได้",
    "update.reason.DOWNLOAD_FAILED": "ดาวน์โหลดไม่สำเร็จ ยังใช้เนื้อหาที่บันทึกไว้",
    "update.reason.INVALID_MANIFEST": "Release manifest ไม่สมบูรณ์",
    "update.reason.MANIFEST_HASH_MISMATCH": "Release manifest ไม่ผ่านการตรวจสอบความสมบูรณ์",
    "update.reason.MANIFEST_BUNDLE_MISMATCH": "Manifest ไม่ตรงกับชุดเนื้อหา",
    "update.reason.BUNDLE_VERIFICATION_FAILED": "ชุดเนื้อหาไม่ผ่านการตรวจ hash หรือลายเซ็น",
    "update.reason.PUBLICATION_INELIGIBLE": "เนื้อหาไม่ผ่านเกณฑ์การเผยแพร่",
    "update.reason.CONFIRMATION_REQUIRED": "ต้องยืนยันก่อนเปลี่ยนชุดเนื้อหา",
    "update.reason.STAGED_UPDATE_MISSING": "ไม่พบอัปเดตที่ตรวจสอบแล้วในพื้นที่พัก",
    "update.reason.ROLLBACK_UNAVAILABLE": "ไม่มีชุดสำรองที่พร้อมใช้งาน",
    "footer.note": "© 2026 craftlab.guru",
    "readiness.open": "ตรวจสอบความพร้อมแบบออฟไลน์",
    "readiness.eyebrow": "ตรวจสอบในอุปกรณ์",
    "readiness.title": "ความพร้อมและการกู้คืน",
    "readiness.body": "ตรวจสอบเฉพาะสถานะในอุปกรณ์ ข้อมูลส่วนตัวจาก Vault จะไม่ปรากฏที่นี่",
    "readiness.signals": "สถานะความพร้อม",
    "readiness.draft.title": "ขอบเขตการตรวจความพร้อมในอุปกรณ์",
    "readiness.draft.explanation":
      "หน้านี้อ่านสถานะทางเทคนิคและข้อมูลสมมติในอุปกรณ์ ไม่ประเมินว่าบุคคลหรือครอบครัวพร้อมรับเหตุจริง",
    "readiness.draft.scope":
      "แอปเชลล์ ชุดเนื้อหา ภาษา แผนครอบครัว Vault ข้อมูลสำรอง และแบบฝึกการกู้คืนสมมติ",
    "readiness.draft.source": "สถานะชุดเนื้อหาและรุ่นทดสอบในหน้า Settings",
    "readiness.draft.limitations":
      "ไม่ตรวจอุปกรณ์จริง เสบียง สุขภาพ สถานที่ หรือความพร้อมของบริการภายนอก และไม่ใช่การรับรองความปลอดภัย",
    "readiness.refresh": "ตรวจสอบอีกครั้ง",
    "readiness.fixture": "สถานะและแบบฝึกนี้ใช้ข้อมูลสมมติเท่านั้น ไม่ใช่คำแนะนำด้านความปลอดภัย",
    "readiness.loading": "กำลังอ่านสถานะในอุปกรณ์…",
    "readiness.state.READY": "พร้อม",
    "readiness.state.NEEDS_ATTENTION": "ควรตรวจสอบ",
    "readiness.state.UNAVAILABLE": "ไม่พร้อมใช้งาน",
    "readiness.state.OPTIONAL": "ไม่บังคับ",
    "readiness.signal.APP_SHELL": "แอปเชลล์แบบออฟไลน์",
    "readiness.signal.SERVICE_WORKER": "ตัวช่วยทำงานออฟไลน์",
    "readiness.signal.ACTIVE_CONTENT": "ชุดเนื้อหาที่ใช้งานอยู่",
    "readiness.signal.KNOWN_GOOD": "ชุดเนื้อหาสำรองที่ตรวจสอบแล้ว",
    "readiness.signal.LOCALE_CONTENT": "เนื้อหาสำหรับภาษาที่เลือก",
    "readiness.signal.CONTENT_FRESHNESS": "ความใหม่ของเนื้อหา",
    "readiness.signal.FAMILY_PLAN": "แผนครอบครัว",
    "readiness.signal.VAULT": "สถานะ Protected Vault",
    "readiness.signal.BACKUP": "ข้อมูลการสำรองล่าสุด",
    "readiness.signal.QUICK_ACCESS": "ส่วนข้อมูลด่วนของแผน",
    "readiness.backup.title": "ตรวจสอบข้อมูลสำรอง",
    "readiness.backup.present": "มี metadata การส่งออกล่าสุด",
    "readiness.backup.none": "ยังไม่พบ metadata การส่งออกข้อมูลสำรอง",
    "readiness.backup.privacy":
      "ระบบเก็บเฉพาะเวลาและรูปแบบของการส่งออก ไม่เก็บข้อความสำรองหรือข้อมูล Vault ในหน้านี้",
    "readiness.backup.data": "วางข้อความข้อมูลสำรองที่เข้ารหัส",
    "readiness.backup.passphrase": "รหัสผ่านของข้อมูลสำรอง",
    "readiness.backup.verify": "ตรวจสอบข้อมูลสำรองในหน่วยความจำ",
    "readiness.backup.VALID": "ตรวจสอบข้อมูลสำรองสำเร็จ ข้อมูลถูกถอดรหัสในหน่วยความจำเท่านั้น",
    "readiness.backup.INVALID": "ตรวจสอบข้อมูลสำรองไม่สำเร็จ ข้อมูลเดิมในอุปกรณ์ไม่ได้ถูกเปลี่ยน",
    "readiness.drill.title": "แบบฝึกกู้คืนสมมติ",
    "readiness.drill.body":
      "เป็นการฝึกใช้หน้าจอแอปอย่างสงบ คุณข้ามหรือออกได้เสมอ ไม่มีคะแนนหรือการแจ้งเตือน",
    "readiness.drill.fixture": "ขั้นตอนสมมติเพื่อทดสอบการใช้งานแอปเท่านั้น",
    "readiness.drill.OFFLINE_OPEN": "ลองเปิดแอปขณะไม่มีอินเทอร์เน็ต",
    "readiness.drill.MEETING_POINT": "ค้นหาจุดนัดพบที่บันทึกไว้",
    "readiness.drill.VAULT_UNLOCK": "ลองปลดล็อก Vault ของคุณ",
    "readiness.drill.CARD_PREVIEW": "สร้างพรีวิวการ์ดสื่อสาร",
    "readiness.drill.BACKUP_RESTORE": "ดูตัวอย่างการกู้คืนข้อมูลสำรองสมมติ",
    "readiness.drill.KNOWN_GOOD_RECOVERY": "ตรวจสอบการใช้ชุดเนื้อหาสำรองที่ตรวจสอบแล้ว",
    "readiness.drill.mark": "ทำเครื่องหมายว่าเสร็จ",
    "readiness.drill.complete": "ทำแล้ว",
    "readiness.drill.restart": "ล้างความคืบหน้าแบบฝึก",
    "readiness.drill.progress": "ทำแล้ว {{completed}} จาก {{total}} ขั้นตอน",
    "readiness.drill.exit": "ออกจากแบบฝึก",
    "readiness.print": "พิมพ์รายการตรวจสอบ",
    "not_found.title": "ไม่พบหน้านี้",
    "not_found.body": "กลับไปยังหน้าหลักเพื่อเลือกส่วนที่ต้องการ",
    "not_found.action": "กลับหน้าหลัก",
  },
  en: {
    "app.name": "SafeSphere",
    "app.tagline": "A safer space starts with preparation",
    "skip.main": "Skip to main content",
    "nav.primary": "Primary navigation",
    "nav.primary_desktop": "Primary navigation for larger screens",
    "nav.primary_mobile": "Primary navigation for mobile devices",
    "nav.home": "Home",
    "nav.emergency": "Emergency",
    "nav.disaster": "Disaster",
    "nav.learn": "Learn",
    "nav.search": "Search",
    "nav.family": "Family Plan",
    "nav.settings": "Settings",
    "nav.about": "About SafeSphere",
    "nav.secondary_desktop": "More information",
    "language.dialog_title": "Choose the language you read comfortably",
    "language.dialog_body": "You can change the language any time in Settings.",
    "language.suggested": "Suggested from your device",
    "language.th": "ไทย",
    "language.en": "English",
    "language.current": "Current language",
    "language.choose": "Change language",
    "language.confirm": "Use this language",
    "status.offline_ready.title": "Offline-ready area",
    "status.offline_ready.body": "This area will show the status of content stored on this device.",
    "status.connection_unavailable.title": "Connection unavailable",
    "status.connection_unavailable.body":
      "Online features are unavailable, but the basic areas remain accessible.",
    "status.update_unavailable.title": "Content update unavailable",
    "status.update_unavailable.body":
      "The app will show update status clearly when that system is available.",
    "status.information": "System information",
    "content_state.ready.title": "Offline content ready",
    "content_state.ready.body":
      "This device has a verified content bundle available without an internet connection.",
    "content_state.never_downloaded.title": "No offline content yet",
    "content_state.never_downloaded.body":
      "Offline storage is ready, but no published bundle exists for this language yet.",
    "content_state.updating.title": "Checking new content",
    "content_state.updating.body":
      "The saved bundle remains active until the new bundle passes every check.",
    "content_state.stale_usable.title": "Saved content remains available",
    "content_state.stale_usable.body":
      "This content may be old. The saved version remains available until a new version is verified.",
    "content_state.update_failed_saved.title": "Using saved content",
    "content_state.update_failed_saved.body":
      "The update failed, so the previously verified bundle was restored.",
    "content_state.recovery_required.title": "Offline content needs recovery",
    "content_state.recovery_required.body":
      "No complete bundle was found. Connect later to attempt recovery.",
    "emergency.action_label": "Quick access",
    "emergency.action": "Preview Emergency Mode",
    "emergency.action_hint": "A calm space for clear steps when you need them.",
    "contacts.reference.eyebrow": "Contact information",
    "contacts.reference.title": "Emergency contact numbers",
    "contacts.reference.unavailable":
      "No contact number has been reviewed and approved for display in this app yet. This does not mean services are unavailable in your area.",
    "contacts.reference.read_only":
      "When approved information is available, numbers will be shown for reading only. The app will not call or send a message for you.",
    "contacts.reference.directory_link": "View all important contacts",
    "contacts.draft.warning":
      "Review draft — the numbers and scopes below come from official sources but do not yet have final publication approval. Check current local official information as well.",
    "contacts.draft.medical": "Emergency medical assistance",
    "contacts.draft.medical_scope":
      "The NIEM source describes a 24-hour emergency medical service; current service scope still requires authority confirmation.",
    "contacts.draft.police": "Immediate public danger",
    "contacts.draft.police_scope":
      "The directly checked source describes a Bangkok answering centre, so nationwide coverage is not claimed.",
    "contacts.draft.fire": "Fire and rescue",
    "contacts.draft.fire_scope":
      "Listed in the government number directory and Bangkok sources; service scope outside Bangkok remains unconfirmed.",
    "contacts.draft.source": "Source",
    "contacts.draft.status": "REVIEW REQUIRED",
    "contacts.draft.disaster_blocked":
      "No disaster information or warning contact is displayed because a current source confirming its exact scope has not yet been captured.",
    "directory.eyebrow": "Offline contact book",
    "directory.title": "Emergency and essential contacts",
    "directory.short_title": "Contact directory",
    "directory.body":
      "Search, filter, copy, or manually initiate a call, with clear coverage and review status.",
    "directory.fixture.title": "Official-source contact directory",
    "directory.fixture.body":
      "Each entry shows its evidence status. A contact with unconfirmed coverage is never presented as nationwide.",
    "directory.search": "Search services or numbers",
    "directory.search.placeholder": "For example medical, fire, water, or province",
    "directory.filters": "Filter by service category",
    "directory.all": "All",
    "directory.priority": "Priority help entries",
    "directory.services": "Other services",
    "directory.tap_note": "Open an entry to inspect source and coverage",
    "directory.copy": "Copy number",
    "directory.copied": "Copied",
    "directory.call": "Call manually",
    "directory.call.notice":
      "The device dial screen opens only after your tap. The app never calls automatically.",
    "directory.favorite.add": "Add favorite",
    "directory.favorite.remove": "Remove favorite",
    "directory.empty.title": "No matching contacts",
    "directory.empty.body":
      "Try a shorter term or another category. The directory will not invent suggestions.",
    "directory.close": "Back to directory",
    "directory.coverage": "Coverage area",
    "directory.status": "Review status",
    "directory.status.draft": "Source-bound draft — awaiting human review",
    "directory.status.stale": "Older information — recheck the source",
    "directory.status.review_required": "Review required — not published information",
    "directory.status.unavailable": "No usable information yet",
    "directory.record.official": "Official record",
    "directory.record.fixture": "Fictional fixture",
    "directory.evidence.draft": "Source-bound draft",
    "directory.evidence.review": "Scope under review",
    "directory.evidence.local": "Local / regional service",
    "directory.reviewed": "Last reviewed",
    "directory.retrieved": "Source retrieved",
    "directory.hours": "Opening hours",
    "directory.source": "Authority and source",
    "directory.unavailable": "Unavailable",
    "directory.limitations.draft":
      "The number and purpose are source-backed, but the record remains a draft without publication approval.",
    "directory.limitations.review":
      "The number or service identity is supported, while coverage, audience, or operations still require review.",
    "directory.limitations.local":
      "The source supports only the stated area and must not be interpreted as nationwide coverage.",
    "directory.category.immediate": "Immediate emergency",
    "directory.category.medical": "Medical and health",
    "directory.category.disaster": "Disaster and weather",
    "directory.category.fire": "Fire and rescue",
    "directory.category.police": "Police and public safety",
    "directory.category.poison": "Poison and chemical help",
    "directory.category.utilities": "Utilities",
    "directory.category.road": "Road and travel",
    "directory.category.social": "Child, older adult, and social support",
    "directory.category.animal": "Animal and pet help",
    "directory.category.local": "Local and regional services",
    "page.home.eyebrow": "Start here",
    "page.home.title": "Choose what you need",
    "page.home.body":
      "A place to learn about everyday risks, accidents, first aid, chemicals, medicines, food, and preparedness, alongside a separate path to help. Safety content is still under review.",
    "page.home.tools": "Explore the subjects",
    "home.paths.title": "Main paths",
    "home.path.help.label": "Help",
    "home.path.help.title": "Need help",
    "home.path.help.body": "Preview the emergency screen. Reviewed guidance is not available yet.",
    "home.path.learn.label": "Learn",
    "home.path.learn.title": "Learn and prepare",
    "home.path.learn.body":
      "Browse a wider set of learning subjects. Real content appears only after review.",
    "home.path.learn.action": "Explore topics",
    "home.section.kicker": "Browse by category",
    "home.categories.count": "9 categories",
    "home.secondary.kicker": "Other subjects",
    "home.secondary.title": "Explore further",
    "learn.eyebrow": "Learning index",
    "learn.title": "Learn to look after yourself",
    "learn.body":
      "Choose a topic, read the essentials first, then open preparation and cautions when needed.",
    "learn.library.kicker": "PRACTICAL PREPAREDNESS LIBRARY",
    "learn.library.title": "Choose a topic to understand and prepare",
    "learn.library.boundary":
      "This content is still under review. Each topic shows its status, with sources in the detail page.",
    "learn.library.diagnostic_count": "10 topics",
    "learn.library.section_count": "8 practical sections",
    "learn.library.detail_boundary":
      "Review-pending information, not live emergency instructions. Follow current local alerts and responders.",
    "learn.library.contacts": "Find official numbers in Contact Directory",
    "learn.library.filters": "Filter by category",
    "learn.library.search_label": "Search topics",
    "learn.library.search_placeholder": "For example, flood or first aid",
    "learn.library.category.all": "All",
    "learn.library.category.hazards": "Hazards and environment",
    "learn.library.category.health": "Health and products",
    "learn.library.category.preparedness": "Preparedness",
    "learn.library.category.public": "Public safety",
    "learn.library.status_label": "Topic status",
    "learn.library.status.research_only": "RESEARCH ONLY",
    "learn.library.status.draft": "DRAFT",
    "learn.library.status.review_required": "Review required",
    "learn.library.status.available": "Metadata available",
    "learn.library.status.coming_later": "Coming later",
    "learn.library.source": "Source and research record",
    "learn.library.source.thailand_dossier":
      "Thailand-first official-source dossier (research record)",
    "learn.library.source.local_tools": "Family Plan on-device tool metadata",
    "learn.library.source.thai_fda": "Thai Food and Drug Administration source record",
    "learn.library.researched_label": "Last researched",
    "learn.library.provenance": "Provenance and boundary",
    "learn.library.publication": "Publication status",
    "learn.library.not_published": "Not published as guidance",
    "learn.library.empty.title": "No topics in this category",
    "learn.library.empty.body":
      "Try another category. The library will not create advice in place of material under review.",
    "learn.library.earthquake.title": "Earthquake",
    "learn.library.earthquake.detail": "Take cover during shaking; watch for damage after it stops",
    "learn.library.tsunami.title": "Tsunami and coastal evacuation",
    "learn.library.tsunami.detail":
      "Recognize natural warnings and know the route to higher ground",
    "learn.library.flood.title": "Flood and storm",
    "learn.library.flood.detail": "Follow alerts, prepare a way out, and avoid floodwater",
    "learn.library.fire.title": "Fire and building evacuation",
    "learn.library.fire.detail": "Know the exits, leave smoke behind, and stay out",
    "learn.library.chemicals.title": "Chemical and product safety",
    "learn.library.chemicals.detail":
      "Read labels, avoid exposure, and follow incident instructions",
    "learn.library.first_aid.title": "First aid",
    "learn.library.first_aid.detail": "Recognize urgent signs, call for help, and assist safely",
    "learn.library.public_safety.title": "Public safety and active threat",
    "learn.library.public_safety.detail": "Leave danger when safe, or find secure shelter",
    "learn.library.family.title": "Family preparedness",
    "learn.library.family.detail": "Prepare contacts, meeting points, and each person's essentials",
    "learn.library.medicines.title": "Medicines, labels, and use information",
    "learn.library.medicines.detail": "Read names, directions, and warnings; ask when unsure",
    "learn.library.food_labels.title": "Food labels and allergen information",
    "learn.library.food_labels.detail": "Check ingredients, allergens, and expiry before eating",
    "learn.detail.explanation": "What this topic is",
    "learn.detail.why": "Remember",
    "learn.detail.scope": "Jurisdiction and scope",
    "learn.detail.sources": "Official source records",
    "learn.detail.sources_note": "These links are source records used for this research.",
    "learn.detail.gaps": "Known gaps and limitations",
    "learn.detail.research_only":
      "Review-pending draft — for learning, not a replacement for incident authorities",
    "learn.detail.category": "Category",
    "learn.detail.review": "Review status",
    "learn.detail.earthquake.explanation":
      "An earthquake is ground shaking that can bring down objects, break glass, and damage buildings. Protecting yourself while shaking continues is more important than rushing outside.",
    "learn.detail.earthquake.why":
      "Near the coast, also read the tsunami topic: a quake may create a further hazard.",
    "learn.detail.earthquake.scope":
      "Thailand through DDPM; USGS is comparative general material, not Thai policy.",
    "learn.detail.earthquake.gaps":
      "Current Thai source coverage and confirmation for damaged buildings, evacuation, disability access, vehicles, and coastal contexts remain incomplete.",
    "learn.detail.tsunami.explanation":
      "A tsunami is a series of large sea waves that may reach the coast after an earthquake or underwater disturbance. Natural signs may precede an alert, so learn the route to higher ground in advance.",
    "learn.detail.tsunami.why":
      "The safe route depends on where you are. Learn the local evacuation signs ahead of time.",
    "learn.detail.tsunami.scope":
      "Thai tsunami-exposed coasts through TMD; NOAA is comparative general material.",
    "learn.detail.tsunami.gaps":
      "Local routes, vertical evacuation, accessibility, and current area-specific warning channels still need confirmation.",
    "learn.detail.flood.explanation":
      "Floods, flash floods, and storms can rapidly raise water, cut routes, and create electrical or contamination hazards. Local alerts help people act sooner.",
    "learn.detail.flood.why":
      "Flash floodwater can rise quickly. A road that looks passable may hide deep or fast water.",
    "learn.detail.flood.scope":
      "Thailand through DDPM and the Department of Health; NWS is comparative U.S. general material.",
    "learn.detail.flood.gaps":
      "Area-specific triggers, flash flooding, electrical context, travel, and evacuation planning require separate verification.",
    "learn.detail.fire.explanation":
      "A building fire brings heat, smoke, and dangerous gases. The main goal is to leave by the escape route and assemble at a safe meeting point.",
    "learn.detail.fire.why":
      "Know the exits in buildings you use often; smoke can make routes hard to see.",
    "learn.detail.fire.scope":
      "Thailand building evacuation through DDPM; USFA is comparative U.S. planning material.",
    "learn.detail.fire.gaps":
      "Current Thai coverage by building type and a confirmed boundary excluding fire suppression are still needed.",
    "learn.detail.chemicals.explanation":
      "Chemicals can enter the body through breathing, skin, eyes, or swallowing. The correct response depends on the substance, so use its label, SDS, and authority instructions.",
    "learn.detail.chemicals.why":
      "The substance and how exposure happened matter. Do not copy a response for a different chemical.",
    "learn.detail.chemicals.scope":
      "Thai public-health material through the Department of Health; CDC is comparative U.S. general material.",
    "learn.detail.chemicals.gaps":
      "Substance-specific material, SDS information, exposure routes, and medical-care boundaries remain unresolved.",
    "learn.detail.first_aid.explanation":
      "First aid is immediate help while professional care is on the way. It begins with scene safety, calling for help, and doing only what the helper can do safely.",
    "learn.detail.first_aid.why":
      "Care varies by person, especially for children, infants, and someone who is unresponsive.",
    "learn.detail.first_aid.scope":
      "Thailand through Thai Red Cross and NIEM material, which have different training and emergency-service contexts.",
    "learn.detail.first_aid.gaps":
      "Current protocol version, intended audience, and clinical boundaries must be confirmed before publication.",
    "learn.detail.public_safety.explanation":
      "A public threat can change quickly, and no single response fits every place. For civilians, the priority is to leave danger when safe or find secure shelter when escape is unsafe.",
    "learn.detail.public_safety.why":
      "A safe exit depends on the venue and the threat's location. Follow responders when you can.",
    "learn.detail.public_safety.scope":
      "A local Thai police information page and comparative U.S. CISA material; it is not Thai national policy.",
    "learn.detail.public_safety.gaps":
      "A central Thai police source, date/scope confirmation, and trauma-informed Thai-context review are still required.",
    "learn.detail.family.explanation":
      "A family plan helps everyone know whom to contact, where to meet, and what each person needs if separated. SafeSphere keeps this information on the device without an account.",
    "learn.detail.family.why":
      "If phones or internet fail, household members should still know the meeting point and backup contact.",
    "learn.detail.family.scope":
      "SafeSphere's on-device Family Plan only; no public-service or nationwide scope is claimed.",
    "learn.detail.family.gaps":
      "Thai-context suitability, individual support needs, and current local-authority guidance still require review before publication.",
    "learn.detail.medicines.explanation":
      "A medicine label identifies the medicine, strength, directions, warnings, expiry, and storage. Checking it every time reduces selection and use errors.",
    "learn.detail.medicines.why":
      "Similar medicine names can have different strengths. Read the label on the pack you are about to use.",
    "learn.detail.medicines.scope":
      "Consumer-facing Thai FDA material for Thailand; it is not personal advice or a prescriber's instruction.",
    "learn.detail.medicines.gaps":
      "Drug interactions, food and herbal products, supplements, high-risk groups, and referral boundaries have not been reviewed for publication.",
    "learn.detail.food_labels.explanation":
      "A food label identifies ingredients, allergens, expiry, and storage conditions. This information helps consumers avoid products that are unsuitable for them.",
    "learn.detail.food_labels.why":
      "Ingredients can change even in a familiar brand, so read its label each time.",
    "learn.detail.food_labels.scope":
      "Thai FDA Food Division requirements and FAQs for Thailand; this is not a list of foods that are safe for an individual.",
    "learn.detail.food_labels.gaps":
      "Individual allergy advice, cross-contact, storage, and medical dietary boundaries have not been reviewed for publication.",
    "learn.detail.everyday.explanation":
      "This overview links official sources about household-product risks and label reading without turning them into response instructions.",
    "learn.detail.everyday.why":
      "Everyday risks vary by product, place, and person and cannot be reduced to one generic procedure.",
    "learn.detail.everyday.scope":
      "Thai Department of Health and Thai FDA sources, organized for research only.",
    "learn.detail.everyday.gaps":
      "Home accidents, electricity, falls, children, older adults, and specialist review remain incomplete.",
    "learn.detail.accidents.explanation":
      "This record organizes first-aid and emergency-medical sources for an accident-topic draft without showing treatment steps.",
    "learn.detail.accidents.why":
      "Accident wording can directly affect health and must be separated by incident type and audience.",
    "learn.detail.accidents.scope":
      "Thai Red Cross and NIEM material used as Thailand research inputs only.",
    "learn.detail.accidents.gaps":
      "A clinician or qualified first-aid educator must review scope, escalation boundaries, and every incident-specific statement.",
    "learn.detail.practical.explanation":
      "This draft describes information-organizing tools and preparedness categories only; it does not prescribe supplies or emergency steps.",
    "learn.detail.practical.why":
      "Organizing information can support personal review but must not be presented as a universal preparedness prescription.",
    "learn.detail.practical.scope":
      "The on-device Family Plan and a DDPM overview source; no household-specific official plan is claimed.",
    "learn.detail.practical.gaps":
      "Preparedness lists still require household, dependent, pet, medicine, document, and location-specific review.",
    "learn.detail.disasters.explanation":
      "This overview links hazard-specific research records without merging different hazards into one guidance sequence.",
    "learn.detail.disasters.why":
      "Each hazard has different warnings, places, and decision thresholds and must be reviewed separately.",
    "learn.detail.disasters.scope":
      "Thailand overview material from DDPM and the Thai Meteorological Department.",
    "learn.detail.disasters.gaps":
      "No specialist-approved routes, safe places, or location-specific decisions are available for publication.",
    "learn.detail.outdoors.explanation":
      "This overview separates forest/mountain, sea/coast, and cold-weather research without teaching survival actions.",
    "learn.detail.outdoors.why":
      "Terrain, weather, equipment, and access to responders vary substantially.",
    "learn.detail.outdoors.scope":
      "DDPM and Thai Meteorological Department overview sources; this is not a field manual.",
    "learn.detail.outdoors.gaps":
      "Environment-specific authorities, field specialists, medical boundaries, and local confirmation remain missing.",
    "learn.detail.outdoors_forest.explanation":
      "This draft records forest and mountain research scope without navigation, food, fire-making, or first-aid instructions.",
    "learn.detail.outdoors_forest.why":
      "Terrain, weather, and distance from responders make generic instructions unreliable.",
    "learn.detail.outdoors_forest.scope":
      "High-level Thailand context through DDPM and weather context through the Thai Meteorological Department.",
    "learn.detail.outdoors_forest.gaps":
      "Forest/mountain, search-and-rescue, and wilderness-medicine specialists must review it before publication.",
    "learn.detail.outdoors_sea.explanation":
      "This draft records sea and coastal research scope without swimming, boating, or in-water survival instructions.",
    "learn.detail.outdoors_sea.why":
      "Waves, currents, vessels, weather, and rescue systems vary by place and time.",
    "learn.detail.outdoors_sea.scope":
      "High-level Thai coast and water context without claiming operational maritime procedures.",
    "learn.detail.outdoors_sea.gaps":
      "Maritime, search-and-rescue, and area-specific warning specialists and sources are still required.",
    "learn.detail.outdoors_cold.explanation":
      "This draft records cold-weather and travel research scope without treatment or survival techniques.",
    "learn.detail.outdoors_cold.why":
      "Cold, wind, moisture, altitude, and personal health all change risk.",
    "learn.detail.outdoors_cold.scope":
      "High-level weather and hazard context, not a snowstorm or cold-medicine field guide.",
    "learn.detail.outdoors_cold.gaps":
      "Specific Thai official sources and meteorology, medical, and mountain-specialist review remain missing.",
    "learn.topics_label": "Learning subjects",
    "learn.status": "Content under review",
    "learn.unavailable":
      "No guidance has been approved for this subject yet, so safety steps are not displayed.",
    "learn.back": "Back to the index",
    "learn.return_to_index": "Back to Learn Library",
    "learn.everyday.title": "Everyday risks",
    "learn.everyday.detail": "Risks at home, at work, and while traveling",
    "learn.accidents.title": "Accidents",
    "learn.accidents.detail": "Unexpected events and getting help",
    "learn.first_aid.title": "First aid",
    "learn.first_aid.detail": "Foundations requiring specialist review",
    "learn.practical.title": "Practical tips",
    "learn.practical.detail": "Small habits and tools for better preparedness",
    "learn.outdoors.title": "Outdoor survival",
    "learn.outdoors.detail": "Choose an environment to find related subjects",
    "learn.outdoors.environments": "Choose an environment",
    "learn.outdoors.back": "Back to environments",
    "learn.outdoors.forest": "Forest and mountains",
    "learn.outdoors.forest_detail": "Travel and becoming stranded on land",
    "learn.outdoors.sea": "Sea and coast",
    "learn.outdoors.sea_detail": "Water travel and coastal settings",
    "learn.outdoors.cold": "Extreme cold and snowstorms",
    "learn.outdoors.cold_detail": "Travel in very cold weather",
    "learn.disasters.title": "Disasters",
    "learn.disasters.detail": "Understanding events and preparing ahead",
    "learn.chemicals.title": "Household products and chemicals",
    "learn.chemicals.detail": "Labels, ingredients, storage, and risks of combined use",
    "learn.chemicals.outline": "Subjects awaiting review",
    "learn.chemicals.labels": "Product labels and ingredients",
    "learn.chemicals.storage": "Storing products at home",
    "learn.chemicals.combinations": "Using products together",
    "learn.chemicals.exposure": "Getting help after exposure",
    "learn.chemicals.unknown":
      "There is no compatibility checker yet. Without enough ingredient information, the result must be ‘unknown’, not ‘safe’.",
    "learn.medicines.title": "Medicines and interactions",
    "learn.medicines.detail": "Medicine labels, combined use, and relationships with food",
    "learn.medicines.outline": "Medicine subjects awaiting review",
    "learn.medicines.labels": "Label information and generic medicine names",
    "learn.medicines.medicine_medicine": "Using multiple medicines together",
    "learn.medicines.medicine_food": "Medicines, food, and drinks",
    "learn.medicines.professional": "Questions for a pharmacist or clinician",
    "learn.medicines.unknown":
      "There is no medicine-interaction checker yet. Do not use this page to decide whether to start, stop, or change a medicine.",
    "learn.food.title": "Food and safety",
    "learn.food.detail": "Labels, allergens, storage, and dietary considerations",
    "learn.food.outline": "Food subjects awaiting review",
    "learn.food.labels": "Food label information",
    "learn.food.allergens": "Allergens and individual restrictions",
    "learn.food.storage": "Food storage and contamination",
    "learn.food.interactions": "Food, drinks, and current medicines",
    "learn.food.unknown":
      "This page does not yet assess food safety or medicine–food interactions. Insufficient information must be shown as ‘unknown’.",
    "home.area.disaster": "Explore a fictional practice flow",
    "home.area.contacts": "Find services by category and coverage, with clear review status",
    "home.area.search": "Find content saved on this device",
    "home.area.family": "Manage a plan stored on this device",
    "home.area.readiness.title": "Offline readiness",
    "home.area.readiness.body": "Check what is available on this device",
    "home.utilities.kicker": "On-device tools",
    "home.utilities.title": "Prepare now, use offline",
    "home.utilities.action": "Open this area",
    "page.emergency.eyebrow": "Quick entry",
    "page.emergency.title": "Emergency Mode",
    "page.emergency.body":
      "Read review-draft contact references and preview a concise, accessible interaction flow.",
    "page.disaster.eyebrow": "Preparedness",
    "page.disaster.title": "Disaster",
    "page.disaster.body":
      "A focused index of disaster subjects being prepared for reviewed, offline publication.",
    "disaster.index.kicker": "Subject index",
    "disaster.index.title": "Prepared with provenance",
    "disaster.index.body":
      "A subject opens only once its sources, language review, and publication approval are complete.",
    "disaster.draft.title": "Disaster research index",
    "disaster.draft.body":
      "This index opens each hazard's research record so readers can inspect its provenance, scope, and unresolved gaps. It does not publish emergency steps.",
    "disaster.draft.scope":
      "Thailand-focused topics using DDPM, Thai Meteorological Department, and the official authorities named on each detail page.",
    "disaster.draft.source": "DDPM public disaster-preparedness handbook",
    "disaster.draft.limitations":
      "Local evacuation routes, safe destinations, scenario thresholds, and high-risk guidance still require specialist review.",
    "disaster.topic.earthquake": "Earthquakes",
    "disaster.topic.earthquake_detail": "Situation awareness and preparedness subject",
    "disaster.topic.flood": "Floods and storms",
    "disaster.topic.flood_detail": "Weather, water, and planning subject",
    "disaster.topic.coast": "Coasts and sea waves",
    "disaster.topic.coast_detail": "Warning signals and coastal-preparedness subject",
    "disaster.topic.fire": "Fire and building evacuation",
    "disaster.topic.fire_detail": "Prevention and safe-exit subject",
    "page.search.eyebrow": "On-device search",
    "page.search.title": "Search",
    "page.search.body":
      "Search content available on this device, and check each result's status before using it.",
    "page.family.eyebrow": "Personal information",
    "page.family.title": "Family Plan",
    "page.family.body":
      "Keep key family information on this device so it remains available when offline.",
    "page.settings.eyebrow": "Preferences",
    "page.settings.title": "Settings",
    "page.settings.body": "Change the display language for this device.",
    "build.stage": "Pre-release testing build",
    "build.stage_short": "TESTING",
    "build.title": "Build information",
    "build.body": "For staging and real-device acceptance. This is not a public release.",
    "build.version": "App version",
    "build.date": "Build date",
    "build.bundle": "Active content bundle",
    "build.bundle_none": "No verified content bundle is active for this language",
    "build.contacts_date": "Contact-directory data date",
    "about.eyebrow": "ABOUT SAFESPHERE",
    "about.title": "Learn, prepare, and look after yourself.",
    "about.body":
      "SafeSphere is a concise learning space for everyday risks, unexpected events, and personal preparedness.",
    "about.purpose_title": "What we are here to do",
    "about.purpose_body":
      "Make important subjects clear, visual, and easy to revisit when needed, while keeping learning content distinct from help-seeking paths.",
    "about.books_eyebrow": "COMING LATER",
    "about.books_title": "Books and learning files",
    "about.books_body": "A home for supplementary books and learning files will be added later.",
    "about.footer_link": "About SafeSphere",
    "support.eyebrow": "SAFE TO SKIP",
    "support.title": "Support SafeSphere",
    "support.body":
      "SafeSphere’s core experience remains free. If you would like to support design and content maintenance, you can leave a contribution on Ko-fi.",
    "support.action": "Support on Ko-fi",
    "support.footer_link": "Support SafeSphere ↗",
    "placeholder.label": "Shell preview",
    "placeholder.not_guidance": "No safety guidance is included in this area yet.",
    "disaster.loading": "Recovering the saved flow…",
    "disaster.fixture_badge": "Test mode — no real guidance",
    "disaster.progress": "Step",
    "disaster.entry.title": "Start the fictional Disaster Mode",
    "disaster.entry.body":
      "This flow uses fictional prompts only to test navigation and recovery. It is not safety guidance.",
    "disaster.start": "Start fictional flow",
    "disaster.step.event": "Which fictional event is happening?",
    "disaster.body.event": "Choose one test event.",
    "disaster.choice.event_a": "Fictional event Alpha",
    "disaster.choice.event_b": "Fictional event Beta",
    "disaster.step.context": "Which fictional context are you in?",
    "disaster.body.context": "Choose one test location type.",
    "disaster.choice.indoor": "Fictional indoor setting",
    "disaster.choice.outdoor": "Fictional outdoor setting",
    "disaster.step.danger": "Is there a fictional immediate-danger condition?",
    "disaster.body.danger": "This answer tests a system branch only.",
    "disaster.choice.danger_yes": "Yes — test condition",
    "disaster.choice.danger_no": "No — test condition",
    "disaster.step.decision": "Choose a fictional decision branch",
    "disaster.body.decision": "These choices do not contain real-world instructions.",
    "disaster.choice.branch_a": "Fictional branch A",
    "disaster.choice.branch_b": "Fictional branch B",
    "disaster.step.action": "Fictional next-action screen",
    "disaster.body.action":
      "This screen displays only reviewed content bound to a trusted content bundle.",
    "disaster.choice.acknowledge": "Acknowledge sample message",
    "disaster.step.continuation": "After the fictional event",
    "disaster.body.continuation": "Choose whether to continue or finish this test.",
    "disaster.choice.continue": "Open fictional continuation",
    "disaster.choice.finish": "Finish fictional flow",
    "disaster.step.complete": "Fictional flow complete",
    "disaster.body.complete": "Navigation testing is complete. No safety guidance was displayed.",
    "disaster.options": "Options for this step",
    "disaster.controls": "Disaster Mode controls",
    "disaster.back": "Back",
    "disaster.restart": "Restart",
    "disaster.exit": "Exit mode",
    "disaster.diagnostics": "Developer state diagnostics",
    "disaster.diagnostics_state": "State",
    "disaster.diagnostics_events": "Permitted events",
    "disaster.diagnostics_history": "Navigation history",
    "binding.loading": "Checking saved verified content…",
    "binding.status.ready": "Verified fictional content",
    "binding.status.stale": "Verified content may be stale",
    "binding.unavailable.title": "Content for this step is unavailable",
    "binding.reason.NO_ACTIVE_BUNDLE": "No verified content bundle is stored on this device.",
    "binding.reason.NO_KNOWN_GOOD_BUNDLE": "No usable retained bundle is available.",
    "binding.reason.BUNDLE_UNTRUSTED": "The content bundle did not pass trust verification.",
    "binding.reason.BUNDLE_SCHEMA_INVALID":
      "The content bundle format is incomplete or unsupported.",
    "binding.reason.LOCALE_MISMATCH": "The content bundle does not match the selected language.",
    "binding.reason.PAYLOAD_INVALID": "The screen content is incomplete.",
    "binding.reason.STATE_MAPPING_MISSING": "No content maps to this step and answer path.",
    "binding.reason.REVISION_MISSING": "The content revision identifier is missing.",
    "binding.reason.REVISION_MISMATCH": "The content revision does not match the reviewed record.",
    "binding.reason.HASH_MISMATCH": "The content does not match the reviewed revision fingerprint.",
    "binding.reason.PUBLICATION_INELIGIBLE": "This content is not eligible for publication.",
    "binding.reason.RETIRED_OR_SUPERSEDED": "This content has been retired or replaced.",
    "binding.return": "Return to previous step",
    "binding.use_known_good": "Use retained verified bundle",
    "binding.provenance": "Source:",
    "binding.reviewed": "Last reviewed:",
    "binding.diagnostics_bundle": "Bundle ID",
    "binding.diagnostics_locale": "Locale",
    "binding.diagnostics_revision": "Revision ID",
    "binding.diagnostics_eligibility": "Eligibility result",
    "library.loading": "Opening the verified content index…",
    "library.unavailable_title": "No content library is available yet",
    "library.unavailable_body": "No verified content bundle is available for this language.",
    "library.search_title": "Search on this device",
    "library.query_label": "Search terms",
    "library.query_placeholder": "Search approved titles, topics, or categories",
    "library.browse": "Browse content",
    "library.categories": "Categories",
    "library.topics": "Topics",
    "library.all": "All",
    "library.results": "Results",
    "library.empty_title": "No matching records",
    "library.empty_body": "Try only the approved topics or categories shown below.",
    "library.matched_by": "Matched by",
    "library.match.TITLE": "title",
    "library.match.TAXONOMY": "topic or category",
    "library.match.ALIAS": "approved synonym",
    "library.match.SUMMARY": "summary",
    "library.back": "Back to results",
    "library.status": "Content status",
    "library.verified": "Verified",
    "library.stale": "Verified but potentially stale",
    "library.topic": "Topic",
    "library.jurisdiction": "Jurisdiction",
    "library.provenance": "Provenance",
    "library.reviewed": "Last reviewed",
    "library.fixture_note": "Fictional system fixture only. This is not safety guidance.",
    "library.diagnostics": "Index diagnostics",
    "library.bundle": "Bundle ID",
    "library.locale": "Locale",
    "library.record_count": "Record count",
    "library.generation": "Index generation",
    "library.source": "Bundle source",
    "family.privacy.title": "Data stays on this device",
    "family.privacy.body":
      "No sign-up or login is required. Quick plan data remains easy to access, while private records are encrypted and opened only with your passphrase.",
    "family.privacy.fact.no_account": "No account required",
    "family.privacy.fact.local": "Stored only in this browser on this device",
    "family.privacy.fact.backup": "Export an encrypted backup before changing devices",
    "family.privacy.warning": "If you forget the passphrase, the app cannot recover vault data.",
    "family.tabs": "Family plan sections",
    "draft.status.RESEARCH_ONLY": "RESEARCH ONLY",
    "draft.status.DRAFT": "DRAFT",
    "draft.status.REVIEW_REQUIRED": "REVIEW REQUIRED",
    "draft.scope": "Scope",
    "draft.source": "Source",
    "draft.researched": "Draft date",
    "draft.limitations": "Limitations",
    "family.draft.title": "Family Plan draft boundary",
    "family.draft.explanation":
      "This is an on-device information-organizing tool, not an official evacuation plan or emergency instruction.",
    "family.draft.scope":
      "Household contacts, meeting points, preparedness lists, Vault records, communication cards, and on-device backup.",
    "family.draft.source": "Family preparedness research record",
    "family.draft.limitations":
      "It remains a single fictional-plan demonstration with no account or sync, and its preparedness lists are not specialist-approved.",
    "family.tab.OVERVIEW": "Overview",
    "family.tab.CONTACTS": "Contacts",
    "family.tab.MEETING": "Meeting points",
    "family.tab.CHECKLISTS": "Preparedness lists",
    "family.tab.VAULT": "Protected vault",
    "family.tab.CARDS": "Reunification cards",
    "family.tab.BACKUP": "Backup and recovery",
    "family.empty": "No family plan is stored on this device yet.",
    "family.load_fixture": "Load fictional test plan",
    "family.plan_label": "Plan label",
    "family.contacts": "Emergency contacts",
    "family.contact_name": "Fictional contact name",
    "family.meeting_points": "Meeting points",
    "family.meeting_label": "Fictional meeting-point label",
    "family.checklists": "Checklists",
    "family.vault.state_locked": "The protected vault is locked",
    "family.vault.state_unlocked": "The vault is temporarily unlocked on this device",
    "family.vault.passphrase": "Vault passphrase",
    "family.vault.create": "Create protected vault",
    "family.vault.unlock": "Unlock",
    "family.vault.lock": "Lock now",
    "family.vault.short": "Use a passphrase with at least 8 characters.",
    "family.vault.created": "The protected vault was created and unlocked.",
    "family.vault.unlocked": "The protected vault is unlocked.",
    "family.vault.incorrect": "The passphrase is incorrect or the vault data is damaged.",
    "family.vault.locked": "The protected vault is locked.",
    "family.vault.kind.MEMBER": "Encrypted member profile",
    "family.vault.kind.PET": "Encrypted pet profile",
    "family.vault.kind.PRIVATE_NOTE": "Encrypted private note",
    "family.vault.records": "Protected records",
    "family.backup.passphrase": "Backup passphrase",
    "family.backup.export": "Create encrypted backup",
    "family.backup.data": "Encrypted backup data",
    "family.backup.preview": "Validate before import",
    "family.backup.confirm": "Confirm import",
    "family.backup.ready": "Encrypted backup data is ready.",
    "family.backup.unlock_required":
      "Unlock the vault and use a passphrase of at least 8 characters.",
    "family.backup.preview_ready": "The backup is valid and ready for confirmation.",
    "family.backup.imported": "The imported records were encrypted on this device.",
    "family.backup.MALFORMED": "The backup is not valid JSON.",
    "family.backup.INCOMPATIBLE": "The backup format or version is not supported.",
    "family.backup.INCORRECT_PASSPHRASE": "The backup passphrase is incorrect.",
    "family.backup.INVALID_DATA": "The backup contents failed validation.",
    "family.diagnostics": "Privacy-safe diagnostics",
    "family.diagnostics_body":
      "Only status and schema versions appear here. Names, health placeholders, notes, and ciphertext are never shown.",
    "family.vault.status": "Vault status",
    "family.plan_schema": "Schema version",
    "cards.privacy_default":
      "Nothing is selected by default. Choose only what is necessary and review the preview before every share or export.",
    "cards.choose_type": "Card type",
    "cards.kind.FAMILY_STATUS": "Family status",
    "cards.kind.OUT_OF_AREA_CONTACT": "Out-of-area contact",
    "cards.kind.MEETING_POINT": "Meeting-point summary",
    "cards.kind.CHILD_SUPPORT": "Child support",
    "cards.kind.OLDER_ADULT_SUPPORT": "Older-adult support",
    "cards.kind.PET_REUNIFICATION": "Pet reunification",
    "cards.kind.COMMUNICATION_TEMPLATE": "Communication message",
    "cards.quick_fields": "Quick plan fields to display",
    "cards.protected_fields": "Protected-vault fields",
    "cards.unlock_required":
      "Unlock the vault in the previous tab before selecting private fields.",
    "cards.sensitive_confirm":
      "I confirm that each selected private field will be visible in the exported or shared card.",
    "cards.confirm_required": "Confirm private-field visibility before creating the preview.",
    "cards.template_choose": "Choose a fictional message",
    "cards.template_edit": "Edit the message before preview",
    "cards.template.I_AM_SAFE": "I am safe",
    "cards.template.MOVING_TO_MEETING_POINT": "Moving to the meeting point",
    "cards.template.CONTACT_THIS_PERSON": "Please contact this person",
    "cards.template.NEED_ASSISTANCE": "I need assistance",
    "cards.template.WE_ARE_SEPARATED": "We are separated",
    "cards.preview": "Create card preview",
    "cards.fixture": "Fictional test fixture only",
    "cards.visibility.SUITABLE_TO_SHARE": "Suitable to share after review",
    "cards.visibility.PRIVATE_DEVICE_ONLY": "Private — keep on this device",
    "cards.visibility.INCLUDES_SENSITIVE": "Includes private information confirmed for visibility",
    "cards.copy": "Copy text",
    "cards.share": "Open share sheet",
    "cards.export_text": "Export text file",
    "cards.print": "Open print view",
    "cards.action.COPIED": "Copied locally on this device.",
    "cards.action.SHARED": "The share sheet was opened; nothing was sent automatically.",
    "cards.action.COPIED_FALLBACK":
      "Sharing was unavailable, so the text was copied locally instead.",
    "cards.action.UNAVAILABLE": "This action is unavailable on this device.",
    "cards.action.EXPORTED": "A local text file was created.",
    "update.eyebrow": "Verified content updates",
    "update.title": "Check and install content bundles",
    "update.body": "Saved content remains usable if the network or update process fails.",
    "update.state.IDLE": "Ready to check for updates",
    "update.state.CHECKING": "Checking for updates…",
    "update.state.UP_TO_DATE": "Saved content is up to date",
    "update.state.DOWNLOADING": "Downloading into staging…",
    "update.state.VERIFYING": "Verified and ready for activation confirmation",
    "update.state.ACTIVATED": "Verified content bundle activated",
    "update.state.FAILED": "Update failed; continuing with saved content",
    "update.bundle": "Bundle ID",
    "update.version": "Version",
    "update.locale": "Locale",
    "update.key": "Signing key",
    "update.check": "Check for updates",
    "update.download": "Download and verify",
    "update.retry": "Retry download",
    "update.activate": "Prepare activation",
    "update.rollback": "Restore retained bundle",
    "update.confirm_title": "Confirm content change",
    "update.confirm_activate":
      "Activate this verified bundle? The current bundle will be retained as known-good.",
    "update.confirm_rollback": "Restore the retained verified bundle?",
    "update.confirm": "Confirm",
    "update.cancel": "Cancel",
    "update.reason.INDEX_UNAVAILABLE":
      "The update index is unavailable; continuing with saved content.",
    "update.reason.INVALID_INDEX": "The update index format is invalid.",
    "update.reason.NO_UPDATE": "No update is available for this language.",
    "update.reason.DOWNLOAD_INTERRUPTED": "The download was interrupted and can be retried.",
    "update.reason.DOWNLOAD_FAILED": "Download failed; continuing with saved content.",
    "update.reason.INVALID_MANIFEST": "The release manifest is incomplete.",
    "update.reason.MANIFEST_HASH_MISMATCH": "The release manifest failed integrity verification.",
    "update.reason.MANIFEST_BUNDLE_MISMATCH": "The manifest does not match the content bundle.",
    "update.reason.BUNDLE_VERIFICATION_FAILED": "The bundle failed hash or signature verification.",
    "update.reason.PUBLICATION_INELIGIBLE": "The content failed publication eligibility checks.",
    "update.reason.CONFIRMATION_REQUIRED": "Confirmation is required before changing content.",
    "update.reason.STAGED_UPDATE_MISSING": "No verified staged update was found.",
    "update.reason.ROLLBACK_UNAVAILABLE": "No retained verified bundle is available.",
    "footer.note": "© 2026 craftlab.guru",
    "readiness.open": "Check offline readiness",
    "readiness.eyebrow": "On-device check",
    "readiness.title": "Readiness and recovery",
    "readiness.body":
      "This page checks on-device status only. Protected Vault plaintext is never shown here.",
    "readiness.signals": "Readiness signals",
    "readiness.draft.title": "On-device readiness-check boundary",
    "readiness.draft.explanation":
      "This page reads technical state and fictional local data; it does not assess whether a person or household is ready for a real incident.",
    "readiness.draft.scope":
      "App shell, content bundles, language, Family Plan, Vault, backup state, and fictional recovery drills.",
    "readiness.draft.source": "Testing-build and content status in Settings",
    "readiness.draft.limitations":
      "It does not inspect real equipment, supplies, health, places, or external-service availability and is not a safety certification.",
    "readiness.refresh": "Refresh checks",
    "readiness.fixture":
      "These statuses and practice flows use fictional fixtures only; they are not safety guidance.",
    "readiness.loading": "Reading local status…",
    "readiness.state.READY": "Ready",
    "readiness.state.NEEDS_ATTENTION": "Needs attention",
    "readiness.state.UNAVAILABLE": "Unavailable",
    "readiness.state.OPTIONAL": "Optional",
    "readiness.signal.APP_SHELL": "Offline app shell",
    "readiness.signal.SERVICE_WORKER": "Offline service worker",
    "readiness.signal.ACTIVE_CONTENT": "Active content bundle",
    "readiness.signal.KNOWN_GOOD": "Retained verified bundle",
    "readiness.signal.LOCALE_CONTENT": "Selected-language content",
    "readiness.signal.CONTENT_FRESHNESS": "Content freshness",
    "readiness.signal.FAMILY_PLAN": "Family Plan",
    "readiness.signal.VAULT": "Protected Vault state",
    "readiness.signal.BACKUP": "Latest backup metadata",
    "readiness.signal.QUICK_ACCESS": "Quick-access plan sections",
    "readiness.backup.title": "Verify a backup",
    "readiness.backup.present": "Latest export metadata is available",
    "readiness.backup.none": "No backup export metadata is available yet",
    "readiness.backup.privacy":
      "This page stores only export time and format metadata. It does not retain backup text or Vault data.",
    "readiness.backup.data": "Paste encrypted backup text",
    "readiness.backup.passphrase": "Backup passphrase",
    "readiness.backup.verify": "Verify backup in memory",
    "readiness.backup.VALID": "Backup verified. It was decrypted in memory only.",
    "readiness.backup.INVALID":
      "Backup could not be verified. Existing device data was not changed.",
    "readiness.drill.title": "Fictional recovery drill",
    "readiness.drill.body":
      "Practice using app screens calmly. You may skip or exit at any time; there is no score, streak, or notification.",
    "readiness.drill.fixture": "A fictional step that tests app behavior only.",
    "readiness.drill.OFFLINE_OPEN": "Open the app while offline",
    "readiness.drill.MEETING_POINT": "Locate a saved meeting point",
    "readiness.drill.VAULT_UNLOCK": "Unlock your Vault",
    "readiness.drill.CARD_PREVIEW": "Preview a communication card",
    "readiness.drill.BACKUP_RESTORE": "Preview a fictional backup recovery",
    "readiness.drill.KNOWN_GOOD_RECOVERY": "Check retained known-good content recovery",
    "readiness.drill.mark": "Mark complete",
    "readiness.drill.complete": "Completed",
    "readiness.drill.restart": "Erase drill progress",
    "readiness.drill.progress": "{{completed}} of {{total}} steps completed",
    "readiness.drill.exit": "Exit drill",
    "readiness.print": "Print checklist",
    "not_found.title": "Page not found",
    "not_found.body": "Return home to choose an available area.",
    "not_found.action": "Return home",
  },
} as const;

export type Locale = keyof typeof translations;
export type TranslationKey = keyof (typeof translations)["th"];

export function isLocale(value: string): value is Locale {
  return value === "th" || value === "en";
}
